export const returnCommunityName = (communityID) => {
    return  AllCommunity.find(e => e.id === communityID) !== null && typeof  AllCommunity.find(e => e.id === communityID) !== 'undefined' ?
        AllCommunity.find(e => e.id === communityID).titleCHI !== '' ? AllCommunity.find(e => e.id === communityID).titleCHI : AllCommunity.find(e => e.id === communityID).title:
        "公海"
}

export const AllCommunity = [
    {
        "id": "debug",
        "title": "Debug",
        "titleCHI": "Tmingler功能改善意見"
    },
    {
        "id": "common",
        "title": "Common",
        "titleCHI": "吹水台"
    },
    {
        "id": "-MFft431uBI99Mu2Oi01",
        "title": "W F JOSEPH LEE PRIMARY SCHOOL",
        "titleCHI": "和富慈善基金李宗德小學"
    },
    {
        "id": "-MFft431sEj4BVYyi9qU",
        "title": "ELCHK LUTHERAN SCHOOL",
        "titleCHI": "基督教香港信義會啟信學校"
    },
    {
        "id": "-MFft431mkTx_nbRdqs1",
        "title": "YUEN LONG PO KOK PRIMARY SCHOOL",
        "titleCHI": "元朗寶覺小學"
    },
    {
        "id": "-MFft431kcI3bfzIK9jz",
        "title": "GIGAMIND ENGLISH PRIMARY SCHOOL",
        "titleCHI": "激活英文小學"
    },
    {
        "id": "-MFft4313vKr14Jix2nY",
        "title": "ELCHK LUTHERAN ACADEMY",
        "titleCHI": "基督教香港信義會宏信書院"
    },
    {
        "id": "-MFft431-x4PU5TcgvnY",
        "title": "UMAH INTERNATIONAL PRIMARY SCHOOL",
        "titleCHI": "穆民國際小學"
    },
    {
        "id": "-MFft430rVi00TTRpPS5",
        "title": "TWGH YIU DAK CHI MEM PRI SCH (YUEN LONG)",
        "titleCHI": "東華三院姚達之紀念小學（元朗）"
    },
    {
        "id": "-MFft430kjdFLJEKGuYJ",
        "title": "TWGH LEO TUNG-HAI LEE PRIMARY SCHOOL",
        "titleCHI": "東華三院李東海小學"
    },
    {
        "id": "-MFft430dRMGTHB-1F1-",
        "title": "YL LONG PING ESTATE TUNG KOON PRI SCH",
        "titleCHI": "元朗朗屏邨東莞學校"
    },
    {
        "id": "-MFft430SJo1Od0o1LQy",
        "title": "YUEN LONG MERCHANTS ASSN PRIMARY SCHOOL",
        "titleCHI": "元朗商會小學"
    },
    {
        "id": "-MFft430Npz8zv0JnZes",
        "title": "YL PUB MID SCH ALUMNI ASSN PRI SCH",
        "titleCHI": "元朗公立中學校友會小學"
    },
    {
        "id": "-MFft430NWzi3y3ofusG",
        "title": "XIANGGANG PTH YANXISHE PRI SCH OF SC & C",
        "titleCHI": "香港普通話研習社科技創意小學"
    },
    {
        "id": "-MFft43085WSc5rHmjQQ",
        "title": "YL PUB MID SCH ALU ASSN YING YIP PRI SCH",
        "titleCHI": "元朗公立中學校友會英業小學"
    },
    {
        "id": "-MFft43070UTrTVrDFeL",
        "title": "YUEN LONG LONG PING ESTATE WAI CHOW SCH",
        "titleCHI": "元朗朗屏邨惠州學校"
    },
    {
        "id": "-MFft43-w4TSG232sBGh",
        "title": "STFA WU MIEN TUEN PRIMARY SCHOOL",
        "titleCHI": "順德聯誼總會伍冕端小學"
    },
    {
        "id": "-MFft43-n1hpa1XbYwGi",
        "title": "SKH TIN SHUI WAI LING OI PRIMARY SCHOOL",
        "titleCHI": "聖公會天水圍靈愛小學"
    },
    {
        "id": "-MFft43-ZEnfe1RbG-6X",
        "title": "SPH RURAL COMMITTEE KUNG YIK SHE PRI SCH",
        "titleCHI": "十八鄉鄉事委員會公益社小學"
    },
    {
        "id": "-MFft43-VI8pE0Yb-lOw",
        "title": "TUN YU SCHOOL",
        "titleCHI": "惇裕學校"
    },
    {
        "id": "-MFft43-Sbg3JDYFDSXr",
        "title": "TIN SHUI WAI METHODIST PRIMARY SCHOOL",
        "titleCHI": "天水圍循道衞理小學"
    },
    {
        "id": "-MFft43-RgJkk8c7ku6x",
        "title": "SKH LING OI PRIMARY SCHOOL",
        "titleCHI": "聖公會靈愛小學"
    },
    {
        "id": "-MFft43-Q3xgS2fSv6WS",
        "title": "TUNG TAK SCHOOL",
        "titleCHI": "通德學校"
    },
    {
        "id": "-MFft43-M7AYiE7EdHEM",
        "title": "QES OLD STUDENTS' ASSOCIATION PRI SCH",
        "titleCHI": "伊利沙伯中學舊生會小學"
    },
    {
        "id": "-MFft43-DDNKDdsG2aXD",
        "title": "SKH ST JOSEPH'S PRIMARY SCHOOL",
        "titleCHI": "聖公會聖約瑟小學"
    },
    {
        "id": "-MFft43-1EAhHl7tS1Tt",
        "title": "TIN SHUI WAI CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "天水圍天主教小學"
    },
    {
        "id": "-MFft42zuPCz1dpVeJ6h",
        "title": "LIONS CLUBS INTL HO TAK SUM PRI SCH",
        "titleCHI": "獅子會何德心小學"
    },
    {
        "id": "-MFft42zi8rDCvJ1A0q_",
        "title": "KWONG MING YING LOI SCHOOL",
        "titleCHI": "光明英來學校"
    },
    {
        "id": "-MFft42zgS_HNuVnSKx4",
        "title": "LOK SIN TONG LEUNG KAU KUI PRI SCH",
        "titleCHI": "樂善堂梁銶琚學校"
    },
    {
        "id": "-MFft42zZ39y-Zgh4y8Q",
        "title": "QES OLD STUDENTS' ASSN BRANCH PRI SCH",
        "titleCHI": "伊利沙伯中學舊生會小學分校"
    },
    {
        "id": "-MFft42zTkXdMDqrS15F",
        "title": "LST LEUNG KAU KUI PRIMARY SCHOOL (BR)",
        "titleCHI": "樂善堂梁銶琚學校（分校）"
    },
    {
        "id": "-MFft42zPEizTNBByVdH",
        "title": "HONG KONG STUDENT AID SOCIETY PRI SCHOOL",
        "titleCHI": "香港學生輔助會小學"
    },
    {
        "id": "-MFft42zISS4Q-nUVjxj",
        "title": "KAM TIN MUNG YEUNG PUBLIC SCHOOL",
        "titleCHI": "錦田公立蒙養學校"
    },
    {
        "id": "-MFft42z6IvCUyUXGJKK",
        "title": "PAT HEUNG CENTRAL PRIMARY SCHOOL",
        "titleCHI": "八鄉中心小學"
    },
    {
        "id": "-MFft42z4nUJxXypIk3m",
        "title": "KWONG MING SCHOOL",
        "titleCHI": "光明學校"
    },
    {
        "id": "-MFft42ypFHalW3fLff8",
        "title": "CHIU YANG POR YEN PRIMARY SCHOOL",
        "titleCHI": "潮陽百欣小學"
    },
    {
        "id": "-MFft42yke4hv3OkAckl",
        "title": "CHUNG SING SCHOOL",
        "titleCHI": "鐘聲學校"
    },
    {
        "id": "-MFft42yX11kYfRH3nwB",
        "title": "HKFYG LEE SHAU KEE PRIMARY SCHOOL",
        "titleCHI": "香港青年協會李兆基小學"
    },
    {
        "id": "-MFft42yTW9rd2MBnpe-",
        "title": "CHIU YANG PRIMARY SCHOOL OF HONG KONG",
        "titleCHI": "香港潮陽小學"
    },
    {
        "id": "-MFft42yRJ-wG_UGOzdG",
        "title": "CUMBERLAND PRESBY CHURCH YAO DAO PRI SCH",
        "titleCHI": "金巴崙長老會耀道小學"
    },
    {
        "id": "-MFft42yFSrszN4Ul7nA",
        "title": "HK & MC LU CH WONG CHAN SOOK YING MEM SC",
        "titleCHI": "港澳信義會黃陳淑英紀念學校"
    },
    {
        "id": "-MFft42yD6E87Xrwq8Qn",
        "title": "CHRISTIAN ALLIANCE S Y YEH MEM PRI SCH",
        "titleCHI": "宣道會葉紹蔭紀念小學"
    },
    {
        "id": "-MFft42y3jHTUCMD-hf3",
        "title": "HO MING PRI SCH SPSD BY SIK SIK YUEN",
        "titleCHI": "嗇色園主辦可銘學校"
    },
    {
        "id": "-MFft42xza15DXXiWfy4",
        "title": "CCC CHUN KWONG PRIMARY SCHOOL",
        "titleCHI": "中華基督教會元朗真光小學"
    },
    {
        "id": "-MFft42xwTSTy3M-MHXP",
        "title": "AD&FDPOHL LEUNG SING TAK SCHOOL",
        "titleCHI": "博愛醫院歷屆總理聯誼會梁省德學校"
    },
    {
        "id": "-MFft42xt-LazzNasOnj",
        "title": "YUEN LONG GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "元朗官立小學"
    },
    {
        "id": "-MFft42xqKEnxNBN3MIu",
        "title": "CHINESE YMCA PRIMARY SCHOOL",
        "titleCHI": "中華基督教青年會小學"
    },
    {
        "id": "-MFft42xpkrAm3gkEErR",
        "title": "BUDDHIST CHAN WING KAN MEMORIAL SCHOOL",
        "titleCHI": "佛教陳榮根紀念學校"
    },
    {
        "id": "-MFft42xOCJGNpGyb66O",
        "title": "BUDDHIST WING YAN SCHOOL",
        "titleCHI": "佛教榮茵學校"
    },
    {
        "id": "-MFft42xIokKEy85KPfW",
        "title": "CCC FONG YUN WAH PRIMARY SCHOOL",
        "titleCHI": "中華基督教會方潤華小學"
    },
    {
        "id": "-MFft42x9foAoQzQ32cV",
        "title": "C & M ALLIANCE CHUI CHAK LAM MEM SCHOOL",
        "titleCHI": "基督教宣道會徐澤林紀念小學"
    },
    {
        "id": "-MFft42x42LK1Hsw72gD",
        "title": "TIN SHUI WAI GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "天水圍官立小學"
    },
    {
        "id": "-MFft42wzpVkhjYlVIBl",
        "title": "YAN TAK CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "仁德天主教小學"
    },
    {
        "id": "-MFft42wqPCIV6gDeoSQ",
        "title": "PLK HK TAOIST ASSN YUEN YUEN PRIMARY SCH",
        "titleCHI": "保良局香港道教聯合會圓玄小學"
    },
    {
        "id": "-MFft42waSh6nVmrXvfN",
        "title": "YAN OI TONG MADAM LAU WONG FAT PRI SCH",
        "titleCHI": "仁愛堂劉皇發夫人小學"
    },
    {
        "id": "-MFft42wZIN3G8mDLAlF",
        "title": "YCH HO SIK NAM PRIMARY SCHOOL",
        "titleCHI": "仁濟醫院何式南小學"
    },
    {
        "id": "-MFft42wQDfvGEpY2Mhm",
        "title": "SOUTH YUEN LONG GOV PRI SCH",
        "titleCHI": "南元朗官立小學"
    },
    {
        "id": "-MFft42wJOqybp-P6R6F",
        "title": "R.T.C. GAIA SCHOOL",
        "titleCHI": "鄉師自然學校"
    },
    {
        "id": "-MFft42w9lkXj6NqPsvI",
        "title": "YCH LAW CHAN CHOR SI PRIMARY SCHOOL",
        "titleCHI": "仁濟醫院羅陳楚思小學"
    },
    {
        "id": "-MFft42w24QVFO_T_zLP",
        "title": "HARROW INTERNATIONAL SCHOOL HONG KONG",
        "titleCHI": "哈羅香港國際學校"
    },
    {
        "id": "-MFft42vuZQuerHrhB4p",
        "title": "TOI SHAN ASSOCIATION PRIMARY SCHOOL",
        "titleCHI": "台山商會學校"
    },
    {
        "id": "-MFft42vltcbejPaxCk5",
        "title": "STFA LEE KAM PRIMARY SCHOOL",
        "titleCHI": "順德聯誼總會李金小學"
    },
    {
        "id": "-MFft42vlmb99u0a-A8_",
        "title": "STFA HO YAT TUNG PRIMARY SCHOOL",
        "titleCHI": "順德聯誼總會何日東小學"
    },
    {
        "id": "-MFft42vf2nJCmJgI0gB",
        "title": "SRBCEPSA HO SAU KI SCHOOL",
        "titleCHI": "柏立基教育學院校友會何壽基學校"
    },
    {
        "id": "-MFft42vRc8HOe3jK-Rm",
        "title": "STFA WU SIU KUI MEMORIAL PRIMARY SCHOOL",
        "titleCHI": "順德聯誼總會胡少渠紀念小學"
    },
    {
        "id": "-MFft42vOGy_4_F88-8M",
        "title": "SKH MUNG YAN PRIMARY SCHOOL",
        "titleCHI": "聖公會蒙恩小學"
    },
    {
        "id": "-MFft42vN6ZmGOgbB_2P",
        "title": "TAOIST CHING CHUNG PRIMARY SCHOOL",
        "titleCHI": "道教青松小學"
    },
    {
        "id": "-MFft42vI84y8Hj-2GAd",
        "title": "TAOIST CHING CHUNG PRI SCH (WU KING EST)",
        "titleCHI": "道教青松小學（湖景邨）"
    },
    {
        "id": "-MFft42v4oZ969mGDSr2",
        "title": "TWGH TANG SHIU KIN PRIMARY SCHOOL",
        "titleCHI": "東華三院鄧肇堅小學"
    },
    {
        "id": "-MFft42uxm_iWiOSFtes",
        "title": "LUTHERAN TSANG SHING SIU LEUN SCHOOL",
        "titleCHI": "香港路德會增城兆霖學校"
    },
    {
        "id": "-MFft42uurFmBQF4XOMi",
        "title": "PLK VICWOOD KT CHONG NO.2 PRIMARY SCHOOL",
        "titleCHI": "保良局莊啓程第二小學"
    },
    {
        "id": "-MFft42uquyAt_a2Et9J",
        "title": "LKWFS LAU TAK YUNG MEMORIAL PRI SCH",
        "titleCHI": "世界龍岡學校劉德容紀念小學"
    },
    {
        "id": "-MFft42uqpsLgd79cADb",
        "title": "PLK HORIZON EAST PRIMARY SCHOOL",
        "titleCHI": "保良局志豪小學"
    },
    {
        "id": "-MFft42uiMFs1FB4GE7R",
        "title": "LOK SIN TONG LEUNG WONG WAI FONG MEM SCH",
        "titleCHI": "樂善堂梁黃蕙芳紀念學校"
    },
    {
        "id": "-MFft42uHNfzeATgpKCk",
        "title": "PLK FONG WONG KAM CHUEN PRIMARY SCHOOL",
        "titleCHI": "保良局方王錦全小學"
    },
    {
        "id": "-MFft42uHG85bYWTyV2p",
        "title": "PLK WWCWD FUNG LEE PUI YIU PRI SCH",
        "titleCHI": "保良局西區婦女福利會馮李佩瑤小學"
    },
    {
        "id": "-MFft42u7qQPenBqBZyM",
        "title": "LUI CHEUNG KWONG LUTHERAN PRIMARY SCHOOL",
        "titleCHI": "路德會呂祥光小學"
    },
    {
        "id": "-MFft42u2m44-nrohxaV",
        "title": "PLK LEUNG CHOW SHUN KAM PRIMARY SCHOOL",
        "titleCHI": "保良局梁周順琴小學"
    },
    {
        "id": "-MFft42taZxQMEjaSMoe",
        "title": "ISLAMIC PRIMARY SCHOOL",
        "titleCHI": "伊斯蘭學校"
    },
    {
        "id": "-MFft42tzHhHOee1l0Gl",
        "title": "CCC MONG WONG FAR YOK MEMORIAL PRI SCH",
        "titleCHI": "中華基督教會蒙黃花沃紀念小學"
    },
    {
        "id": "-MFft42tgSeHklwPbvnJ",
        "title": "CCC BUT SAN PRIMARY SCHOOL",
        "titleCHI": "中華基督教會拔臣小學"
    },
    {
        "id": "-MFft42tbyzmx_mrCTaq",
        "title": "HK ENG CLANSMAN ASSN WU SI CHONG MEM SCH",
        "titleCHI": "僑港伍氏宗親會伍時暢紀念學校"
    },
    {
        "id": "-MFft42tbETqSN5MQSfw",
        "title": "HKRSS TUEN MUN PRIMARY SCHOOL",
        "titleCHI": "香港紅卍字會屯門卍慈小學"
    },
    {
        "id": "-MFft42tNYSfhgpxKvXH",
        "title": "CCC HOH FUK TONG PRIMARY SCHOOL",
        "titleCHI": "中華基督教會何福堂小學"
    },
    {
        "id": "-MFft42tJIaI2ZOdiXZ1",
        "title": "HING TAK SCHOOL",
        "titleCHI": "興德學校"
    },
    {
        "id": "-MFft42tEq5w-_ZCM19f",
        "title": "FDBWA CHOW CHIN YAU SCHOOL",
        "titleCHI": "五邑鄒振猷學校"
    },
    {
        "id": "-MFft42t257_ZmR8bp7a",
        "title": "CASTLE PEAK CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "青山天主教小學"
    },
    {
        "id": "-MFft42sirLzInAVac91",
        "title": "SKH CHU OI PRIMARY SCHOOL (LEI MUK SHUE)",
        "titleCHI": "聖公會主愛小學（梨木樹）"
    },
    {
        "id": "-MFft42scoGyhqnPsUfO",
        "title": "TW PUB HO CHUEN YIU MEM PRIMARY SCHOOL",
        "titleCHI": "荃灣公立何傳耀紀念小學"
    },
    {
        "id": "-MFft42sW6b-bC7NxQAj",
        "title": "TUEN MUN GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "屯門官立小學"
    },
    {
        "id": "-MFft42sUNpxyJSiP8g4",
        "title": "ROSEBUD PRIMARY SCHOOL",
        "titleCHI": "玫瑰蕾小學"
    },
    {
        "id": "-MFft42sK8KD0W5VASZ6",
        "title": "TSUEN WAN CHIU CHOW PUBLIC SCHOOL",
        "titleCHI": "荃灣潮州公學"
    },
    {
        "id": "-MFft42sDynqLizDUjVz",
        "title": "TSUEN WAN CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "荃灣天主教小學"
    },
    {
        "id": "-MFft42sCGtTIIfFpCUV",
        "title": "AD&FDPOH MRS CHENG YAM ON MILL SCH",
        "titleCHI": "博愛醫院歷屆總理聯誼會鄭任安夫人千禧小學"
    },
    {
        "id": "-MFft42s8dDBkQSdTKBd",
        "title": "AD&FDPOHL MRS CHENG YAM ON SCHOOL",
        "titleCHI": "博愛醫院歷屆總理聯誼會鄭任安夫人學校"
    },
    {
        "id": "-MFft42rzPu98OaA9kMc",
        "title": "HOLY CROSS LUTHERAN SCHOOL",
        "titleCHI": "路德會聖十架學校"
    },
    {
        "id": "-MFft42rtmFLPNsHugDS",
        "title": "LEI MUK SHUE CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "梨木樹天主教小學"
    },
    {
        "id": "-MFft42rmFON0boI21M6",
        "title": "HO SHUN PRI SCH (SPSD BY SIK SIK YUEN)",
        "titleCHI": "嗇色園主辦可信學校"
    },
    {
        "id": "-MFft42rb-pQPiVSWQnD",
        "title": "MARY OF PROVIDENCE PRIMARY SCHOOL",
        "titleCHI": "天佑小學"
    },
    {
        "id": "-MFft42rZ8NBHzT2m4Ie",
        "title": "SHAM TSENG CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "深井天主教小學"
    },
    {
        "id": "-MFft42qudf7F6u3Sn0c",
        "title": "CCC KEI WAI PRIMARY SCHOOL (MA WAN)",
        "titleCHI": "中華基督教會基慧小學（馬灣）"
    },
    {
        "id": "-MFft42qnBm-OCNNJYeM",
        "title": "CCC KEI WAI PRIMARY SCHOOL",
        "titleCHI": "中華基督教會基慧小學"
    },
    {
        "id": "-MFft42qm7wmQEOnyRTk",
        "title": "TSUEN WAN GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "荃灣官立小學"
    },
    {
        "id": "-MFft42qYa4UqP8pEg1k",
        "title": "DELIA (MAN KIU) ENGLISH PRIMARY SCHOOL",
        "titleCHI": "地利亞（閩僑）英文小學"
    },
    {
        "id": "-MFft42qYTxHXNfyJ8OO",
        "title": "HKTA YUEN YUEN INST SHEK WAI KOK PRI SCH",
        "titleCHI": "香港道教聯合會圓玄學院石圍角小學"
    },
    {
        "id": "-MFft42qIfqqHLd7DiLg",
        "title": "EMMANUEL PRIMARY SCHOOL",
        "titleCHI": "靈光小學"
    },
    {
        "id": "-MFft42qGtz1CpAgZm5d",
        "title": "CCC CHUEN YUEN FIRST PRI SCHOOL",
        "titleCHI": "中華基督教會全完第一小學"
    },
    {
        "id": "-MFft42q5buSwCvEfJ5l",
        "title": "CHAI WAN KOK CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "柴灣角天主教小學"
    },
    {
        "id": "-MFft42q09mcT3jd1LIr",
        "title": "HOI PA STREET GOVERNMENT PRIMARY SCH",
        "titleCHI": "海壩街官立小學"
    },
    {
        "id": "-MFft42pwCXiXDdvgqqI",
        "title": "TSUEN WAN TRADE ASSOCIATION PRI SCH",
        "titleCHI": "荃灣商會學校"
    },
    {
        "id": "-MFft42poIX2Q0jEi_Uc",
        "title": "SRBCEPSA LEE YAT NGOK MEMORIAL SCHOOL",
        "titleCHI": "柏立基教育學院校友會李一諤紀念學校"
    },
    {
        "id": "-MFft42pmGogYJ5kqNH3",
        "title": "SKH YAN LAAP PRIMARY SCHOOL",
        "titleCHI": "聖公會仁立小學"
    },
    {
        "id": "-MFft42pftIwinm6DH2s",
        "title": "TWGH WONG SEE SUM PRIMARY SCHOOL",
        "titleCHI": "東華三院黃士心小學"
    },
    {
        "id": "-MFft42pcMPHCG8lb0ID",
        "title": "SKH TSING YI EST HO CHAK WAN PRI SCH",
        "titleCHI": "聖公會青衣邨何澤芸小學"
    },
    {
        "id": "-MFft42pTk1NqoPAPLi1",
        "title": "TWGH CHOW YIN SUM PRIMARY SCHOOL",
        "titleCHI": "東華三院周演森小學"
    },
    {
        "id": "-MFft42pPhbxTgVv0yT8",
        "title": "TSING YI TRADE ASSOCIATION PRI SCH",
        "titleCHI": "青衣商會小學"
    },
    {
        "id": "-MFft42pF2tF1MenMxfJ",
        "title": "T.W.G.HS KO HO NING MEM PRI SCH",
        "titleCHI": "東華三院高可寧紀念小學"
    },
    {
        "id": "-MFft42pDGuIfC9_hxVG",
        "title": "YCH CHIU TSANG HOK WAN PRIMARY SCHOOL",
        "titleCHI": "仁濟醫院趙曾學韞小學"
    },
    {
        "id": "-MFft42oi3gcrXMRQ1oo",
        "title": "SALESIAN YIP HON MILLENNIUM PRI SCH",
        "titleCHI": "慈幼葉漢千禧小學"
    },
    {
        "id": "-MFft42ofQTh8me7xDg-",
        "title": "SALESIAN YIP HON PRIMARY SCHOOL",
        "titleCHI": "慈幼葉漢小學"
    },
    {
        "id": "-MFft42oUBS4lBMuaRb0",
        "title": "SKH CHU OI PRIMARY SCHOOL",
        "titleCHI": "聖公會主愛小學"
    },
    {
        "id": "-MFft42oP3HWgEwisUTY",
        "title": "SHEK LEI CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "石籬天主教小學"
    },
    {
        "id": "-MFft42o7zF_df0FM6ho",
        "title": "SHEK LEI ST. JOHN'S CATHOLIC PRIMARY SCH",
        "titleCHI": "石籬聖若望天主教小學"
    },
    {
        "id": "-MFft42o6AT36DcF-Kbz",
        "title": "SKH HO CHAK WAN PRIMARY SCHOOL",
        "titleCHI": "聖公會何澤芸小學"
    },
    {
        "id": "-MFft42o1T05qQ04YCDR",
        "title": "SKH CHU YAN PRIMARY SCHOOL",
        "titleCHI": "聖公會主恩小學"
    },
    {
        "id": "-MFft42nteZIVdxsVye2",
        "title": "FR CUCCHIARA MEMORIAL SCHOOL",
        "titleCHI": "郭怡雅神父紀念學校"
    },
    {
        "id": "-MFft42nlOptGccWge3d",
        "title": "S.K.H. TSING YI CHU YAN PRIMARY SCHOOL",
        "titleCHI": "聖公會青衣主恩小學"
    },
    {
        "id": "-MFft42nbqgm4h4hJryO",
        "title": "ELCHK KWAI SHING LUTHERAN PRI SCH",
        "titleCHI": "基督教香港信義會葵盛信義學校"
    },
    {
        "id": "-MFft42nQhIc35PdMrUp",
        "title": "S.K.H. YAN LAAP MEMORIAL PRIMARY SCHOOL",
        "titleCHI": "聖公會仁立紀念小學"
    },
    {
        "id": "-MFft42n56naLNA87fsa",
        "title": "PO LEUNG KUK CASTAR PRIMARY SCHOOL",
        "titleCHI": "保良局世德小學"
    },
    {
        "id": "-MFft42n4IJVRXkHHKFn",
        "title": "PLK CHAN YAT PRIMARY SCHOOL",
        "titleCHI": "保良局陳溢小學"
    },
    {
        "id": "-MFft42mpQZq9V2sG4bx",
        "title": "CNEC LUI MING CHOI PRIMARY SCHOOL",
        "titleCHI": "中華傳道會呂明才小學"
    },
    {
        "id": "-MFft42ma1LKg92ZRCys",
        "title": "BUDDHIST LIM KIM TIAN MEMORIAL PRI SCH",
        "titleCHI": "佛教林金殿紀念小學"
    },
    {
        "id": "-MFft42mFu_u4hoTSljN",
        "title": "CCC KEI CHUN PRIMARY SCHOOL",
        "titleCHI": "中華基督教會基真小學"
    },
    {
        "id": "-MFft42mBH_71KV9p4um",
        "title": "CCC CHUEN YUEN SECOND PRIMARY SCHOOL",
        "titleCHI": "中華基督教會全完第二小學"
    },
    {
        "id": "-MFft42m9KxoZFM7eVWd",
        "title": "CNEC TA TUNG SCHOOL",
        "titleCHI": "中華傳道會許大同學校"
    },
    {
        "id": "-MFft42m8hwP0T2ZZ1sP",
        "title": "CHO YIU CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "祖堯天主教小學"
    },
    {
        "id": "-MFft42l_PI6pUV5gMGv",
        "title": "NORWEGIAN INTERNATIONAL  SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft42l_EPdp9Ops_mF",
        "title": "INT'L COLLEGE HK HONG LOK YUEN (PRI SEC)",
        "titleCHI": null
    },
    {
        "id": "-MFft42lPh5smIaSAOyY",
        "title": "JAPANESE INTERNATIONAL SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft42lOVuiECqaEhST",
        "title": "MALVERN COLLEGE HONG KONG",
        "titleCHI": "香港墨爾文國際學校"
    },
    {
        "id": "-MFft42lO8TgSha9F_3m",
        "title": "BUDD LAM BING YIM MEM SCH (SPSD BY HKBA)",
        "titleCHI": "佛教林炳炎紀念學校（香港佛教聯合會主辦）"
    },
    {
        "id": "-MFft42lFB43QuSrqecU",
        "title": "ST. HILARY'S PRIMARY SCHOOL",
        "titleCHI": "德萃小學"
    },
    {
        "id": "-MFft42lEwy5zFNPO9nv",
        "title": "ASBURY METHODIST PRIMARY SCHOOL",
        "titleCHI": "亞斯理衛理小學"
    },
    {
        "id": "-MFft42kk716Sfv468IY",
        "title": "AMERICAN SCHOOL HONG KONG",
        "titleCHI": null
    },
    {
        "id": "-MFft42kc8jF3YweXM-t",
        "title": "TAI PO METHODIST SCHOOL",
        "titleCHI": "大埔循道衛理小學"
    },
    {
        "id": "-MFft42k_gYhvxCtYwal",
        "title": "TAI PO OLD MARKET PUBLIC SCHOOL",
        "titleCHI": "大埔舊墟公立學校"
    },
    {
        "id": "-MFft42kWZtGufLHRghE",
        "title": "TAI PO BAPTIST PUBLIC SCHOOL",
        "titleCHI": "大埔浸信會公立學校"
    },
    {
        "id": "-MFft42kTxt7iTp0M6ML",
        "title": "YCH CHOI HIN TO PRIMARY SCHOOL",
        "titleCHI": "仁濟醫院蔡衍濤小學"
    },
    {
        "id": "-MFft42kE66fDTvCcJLs",
        "title": "TAI PO OLD MARKET PUB SCH (PLOVER COVE)",
        "titleCHI": "大埔舊墟公立學校（寶湖道）"
    },
    {
        "id": "-MFft42jz9-6tnP2vNZS",
        "title": "SUNG TAK WONG KIN SHEUNG MEMORIAL SCHOOL",
        "titleCHI": "大埔崇德黃建常紀念學校"
    },
    {
        "id": "-MFft42jtoiBSwdX4UvG",
        "title": "SKH YUEN CHEN MAUN CHEN PRIMARY SCHOOL",
        "titleCHI": "聖公會阮鄭夢芹小學"
    },
    {
        "id": "-MFft42jZcSjmGODbibd",
        "title": "SAM SHUI NATIVES ASSO HUEN KING WING SCH",
        "titleCHI": "三水同鄉會禤景榮學校"
    },
    {
        "id": "-MFft42j5O6k5lA3aR7L",
        "title": "PLK TIN KA PING MILLENNIUM PRI SCHOOL",
        "titleCHI": "保良局田家炳千禧小學"
    },
    {
        "id": "-MFft42j3aL8KU4RAdEa",
        "title": "S.K.H. YUEN CHEN MAUN CHEN JUBILEE P.S.",
        "titleCHI": "聖公會阮鄭夢芹銀禧小學"
    },
    {
        "id": "-MFft42j15tBc_-sXHsv",
        "title": "PLK TIN KA PING PRIMARY SCHOOL",
        "titleCHI": "保良局田家炳小學"
    },
    {
        "id": "-MFft42j0asZzesBDEK6",
        "title": "SACRED HEART OF MARY CATHOLIC PRI SCH",
        "titleCHI": "天主教聖母聖心小學"
    },
    {
        "id": "-MFft42ix3jp630nX47z",
        "title": "NTW&JWA LEUNG SING TAK PRIMARY SCHOOL",
        "titleCHI": "新界婦孺福利會有限公司梁省德學校"
    },
    {
        "id": "-MFft42iNfpxdGqUGjym",
        "title": "HKTA WUN TSUEN NG LAI WO MEMORIAL SCHOOL",
        "titleCHI": "香港道教聯合會雲泉吳禮和紀念學校"
    },
    {
        "id": "-MFft42i8BpyqG6zGIL_",
        "title": "NTWJWA CHRISTIAN REMEMBRANCE OF GRACE PS",
        "titleCHI": "新界婦孺福利會基督教銘恩小學"
    },
    {
        "id": "-MFft42i5FV6mIELQXwx",
        "title": "HK&KLNKW ASSO SUN FONG CHUNG PRI SCH",
        "titleCHI": "港九街坊婦女會孫方中小學"
    },
    {
        "id": "-MFft42i3LaVHxXRyKGh",
        "title": "EDUHK JOCKEY CLUB PRI SCH",
        "titleCHI": "香港教育大學賽馬會小學"
    },
    {
        "id": "-MFft42i1mRq0TJPFyxL",
        "title": "LAM TSUEN PUB WONG FOOK LUEN MEM SCH",
        "titleCHI": "林村公立黃福鑾紀念學校"
    },
    {
        "id": "-MFft42h4Lw_cecyrPLH",
        "title": "TAI PO GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "大埔官立小學"
    },
    {
        "id": "-MFft42hiBCZMPRIgSnq",
        "title": "PUI KIU COLLEGE",
        "titleCHI": "培僑書院"
    },
    {
        "id": "-MFft42haNuqGM0HawC2",
        "title": "INTERNATIONAL CHRISTIAN SCHOOL",
        "titleCHI": "基督教國際學校"
    },
    {
        "id": "-MFft42hLMalAl8enqqj",
        "title": "HKBUAS WONG KAM FAI SEC & PRI SCH",
        "titleCHI": "香港浸會大學附屬學校王錦輝中小學"
    },
    {
        "id": "-MFft42hJUt5ThXywqJL",
        "title": "ANFIELD SCHOOL",
        "titleCHI": "安菲爾學校"
    },
    {
        "id": "-MFft42hGG0rwkgnxVnr",
        "title": "RENAISSANCE COLLEGE",
        "titleCHI": "啓新書院"
    },
    {
        "id": "-MFft42hBsVYqIac-4O4",
        "title": "SHATIN JUNIOR SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft42ghyivDTavFgN8",
        "title": "TWGHS SHUI CHUEN O PRIMARY SCHOOL",
        "titleCHI": "東華三院水泉澳小學"
    },
    {
        "id": "-MFft42gjg9gO4PtOqr8",
        "title": "SKH MA ON SHAN HOLY SPIRIT PRIMARY SCH",
        "titleCHI": "聖公會馬鞍山主風小學"
    },
    {
        "id": "-MFft42g_IUnwh5BoMfm",
        "title": "STEWARDS POOI KEI PRIMARY SCHOOL",
        "titleCHI": "培基小學"
    },
    {
        "id": "-MFft42gYgzpn_UzByiq",
        "title": "THE ELCHK WO CHE LUTHERAN SCHOOL",
        "titleCHI": "基督教香港信義會禾輋信義學校"
    },
    {
        "id": "-MFft42gPmzDXUw2CdKg",
        "title": "THE LITTLE FLOWER'S CATHOLIC PRIMARY SCH",
        "titleCHI": "天主教聖華學校"
    },
    {
        "id": "-MFft42gPdk0PoBi2kOQ",
        "title": "TWGH SIN CHU WAN PRIMARY SCHOOL",
        "titleCHI": "東華三院冼次雲小學"
    },
    {
        "id": "-MFft42gD6aDSzZSYxeJ",
        "title": "THE ELCHK MA ON SHAN LUTHERAN PRI SCH",
        "titleCHI": "基督教香港信義會馬鞍山信義學校"
    },
    {
        "id": "-MFft42fsCWbjYzXvevu",
        "title": "SKH HOLY SPIRIT PRIMARY SCHOOL",
        "titleCHI": "聖公會主風小學"
    },
    {
        "id": "-MFft42fg-v9g0mHkwPh",
        "title": "SHA TIN METHODIST PRIMARY SCHOOL",
        "titleCHI": "沙田循道衛理小學"
    },
    {
        "id": "-MFft42fcFWtssSEtACg",
        "title": "PLK SIU HON-SUM PRIMARY SCHOOL",
        "titleCHI": "保良局蕭漢森小學"
    },
    {
        "id": "-MFft42fYP-MeqmwN3ok",
        "title": "SHA TIN WAI DR. CATHERINE F. WOO MEM SCH",
        "titleCHI": "沙田圍胡素貞博士紀念學校"
    },
    {
        "id": "-MFft42fMCBR6JFGzSGC",
        "title": "SHATIN TSUNG TSIN SCHOOL",
        "titleCHI": "沙田崇真學校"
    },
    {
        "id": "-MFft42fJJqdczP1IK9Z",
        "title": "SA TIN KA PING SCHOOL",
        "titleCHI": "救世軍田家炳學校"
    },
    {
        "id": "-MFft42eqhay9syH9YoQ",
        "title": "MA ON SHAN ST. JOSEPH'S PRIMARY SCHOOL",
        "titleCHI": "馬鞍山聖若瑟小學"
    },
    {
        "id": "-MFft42ep6fw8Bqdgh7z",
        "title": "PLK CHONG KEE TING PRIMARY SCHOOL",
        "titleCHI": "保良局莊啟程小學"
    },
    {
        "id": "-MFft42eiyR7cWvcYxft",
        "title": "PLK CHEE JING YIN PRIMARY SCHOOL",
        "titleCHI": "保良局朱正賢小學"
    },
    {
        "id": "-MFft42egqp6IhXMb1CP",
        "title": "PLK DR. JIMMY WONG CHI-HO (TSV) P S",
        "titleCHI": "保良局王賜豪（田心谷）小學"
    },
    {
        "id": "-MFft42eUXLhoMS8_28F",
        "title": "PLK RIVERAIN PRIMARY SCHOOL",
        "titleCHI": "保良局雨川小學"
    },
    {
        "id": "-MFft42e4puKIdEFKfcM",
        "title": "NG CLAN'S ASSN TAI PAK MEM SCH",
        "titleCHI": "吳氏宗親總會泰伯紀念學校"
    },
    {
        "id": "-MFft42doz4NFUBwjSxX",
        "title": "LKWFS WONG YIU NAM PRIMARY SCHOOL",
        "titleCHI": "世界龍岡學校黃耀南小學"
    },
    {
        "id": "-MFft42dfHDSrEL3zo7-",
        "title": "KCBC HAY NIEN (YAN PING) PRI SCH",
        "titleCHI": "九龍城浸信會禧年（恩平）小學"
    },
    {
        "id": "-MFft42dVaZlBMDBlY0-",
        "title": "MA ON SHAN METHODIST PRIMARY SCHOOL",
        "titleCHI": "馬鞍山循道衛理小學"
    },
    {
        "id": "-MFft42dQRLESYsvIjRt",
        "title": "LEUNG KUI KAU LUTHERAN PRIMARY SCHOOL",
        "titleCHI": "路德會梁鉅鏐小學"
    },
    {
        "id": "-MFft42dMLDmtaeIZx9i",
        "title": "MA ON SHAN LING LIANG PRIMARY SCHOOL",
        "titleCHI": "馬鞍山靈糧小學"
    },
    {
        "id": "-MFft42d1qNwkgkcN0lO",
        "title": "KOWLOON CITY BAPTIST CH HAY NIEN PRI SCH",
        "titleCHI": "九龍城浸信會禧年小學"
    },
    {
        "id": "-MFft42czG8YJ6u1_JqJ",
        "title": "IMMACULATE HEART OF MARY SCHOOL",
        "titleCHI": "聖母無玷聖心學校"
    },
    {
        "id": "-MFft42culpAtt4yhevX",
        "title": "GCC&ITKD CHEONG WONG WAI PRI SCH",
        "titleCHI": "東莞工商總會張煌偉小學"
    },
    {
        "id": "-MFft42ca44dhzLjV0RS",
        "title": "HKTA SHUN YEUNG PRIMARY SCHOOL",
        "titleCHI": "香港道教聯合會純陽小學"
    },
    {
        "id": "-MFft42c_b5Qr8rxmgHh",
        "title": "FREE METHODIST BRADBURY CHUN LEI PRI SCH",
        "titleCHI": "循理會白普理基金循理小學"
    },
    {
        "id": "-MFft42cQdLbXAFhUxh0",
        "title": "DR CATHERINE F WOO MEMORIAL SCHOOL",
        "titleCHI": "胡素貞博士紀念學校"
    },
    {
        "id": "-MFft42ba-b33cdoUdpc",
        "title": "BAPTIST (STW) LUI MING CHOI PRIM SCH",
        "titleCHI": "浸信會沙田圍呂明才小學"
    },
    {
        "id": "-MFft42bYIDviksfDp20",
        "title": "CHI HONG PRIMARY SCHOOL",
        "titleCHI": "慈航學校"
    },
    {
        "id": "-MFft42bXG-xIDcFvQGb",
        "title": "SHA TIN GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "沙田官立小學"
    },
    {
        "id": "-MFft42bQ8n6aNzfzW4V",
        "title": "CARMEL ALISON LAM PRIMARY SCHOOL",
        "titleCHI": "迦密愛禮信小學"
    },
    {
        "id": "-MFft42bL9ErK6Y-IE_d",
        "title": "YUK YIN SCHOOL",
        "titleCHI": "育賢學校"
    },
    {
        "id": "-MFft42b6aK52ltJ_HBW",
        "title": "BAPTIST LUI MING CHOI PRIMARY SCHOOL",
        "titleCHI": "浸信會呂明才小學"
    },
    {
        "id": "-MFft42b459TQmSSe44d",
        "title": "CHRISTIAN ALLIANCE H C CHAN PRI SCH",
        "titleCHI": "香港九龍塘基督教中華宣道會陳元喜小學"
    },
    {
        "id": "-MFft42audW_vbqqBYgL",
        "title": "WAI CHOW PUBLIC SCHOOL (SHEUNG SHUI)",
        "titleCHI": "上水惠州公立學校"
    },
    {
        "id": "-MFft42amzwTDYYQhHdH",
        "title": "TWGHS MA KAM CHAN MEM PRI SCH",
        "titleCHI": "東華三院馬錦燦紀念小學"
    },
    {
        "id": "-MFft42akkYHbCL--UxX",
        "title": "TWGHS MA KAM CHAN MEM PRI SCH",
        "titleCHI": "東華三院馬錦燦紀念小學"
    },
    {
        "id": "-MFft42akG7u9vV9o7Lc",
        "title": "TSANG MUI MILLENNIUM SCHOOL",
        "titleCHI": "曾梅千禧學校"
    },
    {
        "id": "-MFft42aUhOU5DlPmt83",
        "title": "TUNG KOON SCHOOL",
        "titleCHI": "東莞學校"
    },
    {
        "id": "-MFft42aSj9urSitDxfF",
        "title": "TWGH HK & KLN ETC APP MER ASSN LTD SCH",
        "titleCHI": "東華三院港九電器商聯會小學"
    },
    {
        "id": "-MFft42_r0a5Iw2D1qVa",
        "title": "SHEK WU HUI PUBLIC SCHOOL",
        "titleCHI": "石湖墟公立學校"
    },
    {
        "id": "-MFft42_beIQ6QI_BtrH",
        "title": "SKH WING CHUN PRIMARY SCHOOL",
        "titleCHI": "聖公會榮真小學"
    },
    {
        "id": "-MFft42_LlVgd60f1aK3",
        "title": "SHA TAU KOK CENTRAL PRIMARY SCHOOL",
        "titleCHI": "沙頭角中心小學"
    },
    {
        "id": "-MFft42_GCJhV3b_EJQ1",
        "title": "PUI LING SCHOOL OF THE PRECIOUS BLOOD",
        "titleCHI": "寶血會培靈學校"
    },
    {
        "id": "-MFft42_FyvhW4cxiybF",
        "title": "TA KU LING LING YING PUBLIC SCHOOL",
        "titleCHI": "打鼓嶺嶺英公立學校"
    },
    {
        "id": "-MFft42_Af6VLYqf48gj",
        "title": "SKH KA FUK WING CHUN PRIMARY SCHOOL",
        "titleCHI": "聖公會嘉福榮真小學"
    },
    {
        "id": "-MFft42_67rTwspv6TAM",
        "title": "PENTECOSTAL YU LEUNG FAT PRIMARY SCHOOL",
        "titleCHI": "五旬節于良發小學"
    },
    {
        "id": "-MFft42Zk4v228CyUnh-",
        "title": "HHCKLA BUDDHIST CHAN SHI WAN PRIMARY SCH",
        "titleCHI": "香海正覺蓮社佛教陳式宏學校"
    },
    {
        "id": "-MFft42Zd3SuGIaWtfrW",
        "title": "HHCKLA BUDDHIST WISDOM PRI SCH",
        "titleCHI": "香海正覺蓮社佛教正慧小學"
    },
    {
        "id": "-MFft42ZLuMJGdZp5pPI",
        "title": "LEE CHI TAT MEMORIAL SCHOOL",
        "titleCHI": "李志達紀念學校"
    },
    {
        "id": "-MFft42ZL9oKE5wafag0",
        "title": "KAM TSIN VILLAGE HO TUNG SCHOOL",
        "titleCHI": "金錢村何東學校"
    },
    {
        "id": "-MFft42Z2ZnvPCV353HU",
        "title": "PENTECOSTAL GIN MAO SHENG PRIMARY SCHOOL",
        "titleCHI": "五旬節靳茂生小學"
    },
    {
        "id": "-MFft42Z1nyGtup3Tlup",
        "title": "HHCKLA BUDDHIST CHING KOK LIN ASS SCHOOL",
        "titleCHI": "香海正覺蓮社佛教正覺蓮社學校"
    },
    {
        "id": "-MFft42YbvavOAMBjjLQ",
        "title": "FUK TAK EDUCATION SOCIETY PRIMARY SCHOOL",
        "titleCHI": "福德學社小學"
    },
    {
        "id": "-MFft42YUhla918MClvO",
        "title": "FSFTF FONG SHU CHUEN PRI SCH",
        "titleCHI": "方樹福堂基金方樹泉小學"
    },
    {
        "id": "-MFft42YCNa29KOlSS1s",
        "title": "FUK TAK EDUCATION SOCIETY PRIMARY SCHOOL",
        "titleCHI": "福德學社小學"
    },
    {
        "id": "-MFft42YC8AtAybQdf3w",
        "title": "FUNG KAI NO.1 PRIMARY SCHOOL",
        "titleCHI": "鳳溪第一小學"
    },
    {
        "id": "-MFft42Y5kDAabQ1TPIJ",
        "title": "FUNG KAI LIU YUN-SUM MEMORIAL SCHOOL",
        "titleCHI": "鳳溪廖潤琛紀念學校"
    },
    {
        "id": "-MFft42Y4DDKdEvugBnJ",
        "title": "FUNG KAI INNOVATIVE SCHOOL",
        "titleCHI": "鳳溪創新小學"
    },
    {
        "id": "-MFft42XN2S1mXIdA6D1",
        "title": "FANLING PUBLIC SCHOOL",
        "titleCHI": "粉嶺公立學校"
    },
    {
        "id": "-MFft42Xy-P8oRN0PGgf",
        "title": "VNSAA ST. HILARY'S SCHOOL",
        "titleCHI": "漢師德萃學校"
    },
    {
        "id": "-MFft42XsbHEraqk9WFr",
        "title": "ALLIANCE PRIMARY SCHOOL, SHEUNG SHUI",
        "titleCHI": "上水宣道小學"
    },
    {
        "id": "-MFft42XY2kNJjelm7Lp",
        "title": "DIOCESAN GIRLS' JUNIOR SCHOOL",
        "titleCHI": "拔萃女小學"
    },
    {
        "id": "-MFft42XIhM2Rl7xfaKB",
        "title": "FANLING GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "粉嶺官立小學"
    },
    {
        "id": "-MFft42XHBofsV4rmWdt",
        "title": "FANLING ASSEMBLY OF GOD CHURCH PRI SCH",
        "titleCHI": "基督教粉嶺神召會小學"
    },
    {
        "id": "-MFft42X-5ITv97Qc0s2",
        "title": "MOUNT KELLY SCHOOL HONG KONG",
        "titleCHI": "香港凱莉山學校"
    },
    {
        "id": "-MFft42WrwOJ4LGr4Chk",
        "title": "G. T. (ELLEN YEUNG) COLLEGE",
        "titleCHI": "優才（楊殷有娣）書院"
    },
    {
        "id": "-MFft42Wbmpc1UlC_6Va",
        "title": "TWGH LO YU CHIK PRIMARY SCHOOL",
        "titleCHI": "東華三院羅裕積小學"
    },
    {
        "id": "-MFft42WRfTVUEHuyf6l",
        "title": "YAUMATI KAIFONG ASSOCIATION SCHOOL",
        "titleCHI": "油蔴地街坊會學校"
    },
    {
        "id": "-MFft42WQopHYwlCyDKg",
        "title": "YAUMATI CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "油蔴地天主教小學"
    },
    {
        "id": "-MFft42WOGsb9AlrK3V6",
        "title": "PLK CAMOES TAN SIU LIN PRIMARY SCHOOL",
        "titleCHI": "保良局陳守仁小學"
    },
    {
        "id": "-MFft42WMc-Xs7i3fDZv",
        "title": "YAUMATI CATHOLIC PRI SCH (HOI WANG RD)",
        "titleCHI": "油蔴地天主教小學（海泓道）"
    },
    {
        "id": "-MFft42WAIRHk-b-3pc9",
        "title": "DALTON SCHOOL HONG KONG",
        "titleCHI": "香港道爾頓學校"
    },
    {
        "id": "-MFft42VtkxejnCOkm0e",
        "title": "TAK SUN SCHOOL",
        "titleCHI": "德信學校"
    },
    {
        "id": "-MFft42VpJ15H7z3HbqY",
        "title": "METHODIST SCHOOL",
        "titleCHI": "循道學校"
    },
    {
        "id": "-MFft42VoEMROgeeRUoC",
        "title": "ST MARY'S CANOSSIAN SCHOOL",
        "titleCHI": "嘉諾撒聖瑪利學校"
    },
    {
        "id": "-MFft42VK4jTZc78oA8_",
        "title": "SKH KEI WING PRIMARY SCHOOL",
        "titleCHI": "聖公會基榮小學"
    },
    {
        "id": "-MFft42VIm7JbdmshvER",
        "title": "TUNG KOON DIST SOC FONG SHU CHUEN SCH",
        "titleCHI": "東莞同鄉會方樹泉學校"
    },
    {
        "id": "-MFft42VGu1D0egAEWlz",
        "title": "TAI KOK TSUI CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "大角嘴天主教小學"
    },
    {
        "id": "-MFft42V6L_Y2rpZvydc",
        "title": "SHARON LUTHERAN SCHOOL",
        "titleCHI": "路德會沙崙學校"
    },
    {
        "id": "-MFft42V5c4O6ozCaNgG",
        "title": "TKT CATHOLIC PRIMARY SCHOOL (HOI FAN RD)",
        "titleCHI": "大角嘴天主教小學（海帆道）"
    },
    {
        "id": "-MFft42Ud2-RDCjGel7M",
        "title": "CCC KEI TSUN PRIMARY SCHOOL",
        "titleCHI": "中華基督教會基全小學"
    },
    {
        "id": "-MFft42UaoxWl7NicUrR",
        "title": "FRESH FISH TRADERS' SCHOOL",
        "titleCHI": "鮮魚行學校"
    },
    {
        "id": "-MFft42UYHREWMNhuAmy",
        "title": "CCC HEEP WOH PRIMARY SCHOOL",
        "titleCHI": "中華基督教會協和小學"
    },
    {
        "id": "-MFft42UQE7TmmvCVKtZ",
        "title": "JORDAN ROAD GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "佐敦道官立小學"
    },
    {
        "id": "-MFft42UIH3GVdt6vDXr",
        "title": "TONG MEI ROAD GOVERNMENT PRIMARY SCH",
        "titleCHI": "塘尾道官立小學"
    },
    {
        "id": "-MFft42UD5wrXd7sz0VA",
        "title": "KOWLOON WOMEN'S WEL CLUB LI PING MEM SCH",
        "titleCHI": "九龍婦女福利會李炳紀念學校"
    },
    {
        "id": "-MFft42U9G6VDgAOI4_r",
        "title": "CCC WANCHAI CHURCH KEI TO PRIMARY SCHOOL",
        "titleCHI": "中華基督教會灣仔堂基道小學"
    },
    {
        "id": "-MFft42TscKowKbZm5AN",
        "title": "CANTON ROAD GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "廣東道官立小學"
    },
    {
        "id": "-MFft42TrYz80vYY__-X",
        "title": "INTL CHR QUALITY MUSIC SEC & PRI SCHOOL",
        "titleCHI": "國際基督教優質音樂中學暨小學"
    },
    {
        "id": "-MFft42Tk1zoUb_6mhUU",
        "title": "GOOD HOPE PRI SCH CUM KG",
        "titleCHI": "德望小學暨幼稚園"
    },
    {
        "id": "-MFft42TeOO3yTAlIkfp",
        "title": "WONG TAI SIN CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "黃大仙天主教小學"
    },
    {
        "id": "-MFft42TZ7HgAnuqtISn",
        "title": "TWS ST BONAVENTURE CATHOLIC PRIMARY SCH",
        "titleCHI": "慈雲山聖文德天主教小學"
    },
    {
        "id": "-MFft42TSTXslC2RWzo4",
        "title": "ASSEMBLY OF GOD MORRISON COLLEGE",
        "titleCHI": "神召會馬理信書院"
    },
    {
        "id": "-MFft42TRXgIE5QFK4DF",
        "title": "OUR LADY'S PRIMARY SCHOOL",
        "titleCHI": "聖母小學"
    },
    {
        "id": "-MFft42S_-URNGLeseVQ",
        "title": "ST BONAVENTURE CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "聖文德天主教小學"
    },
    {
        "id": "-MFft42SJY3-ENLGvptV",
        "title": "ST PATRICK'S CATH PRI SCH (P K VILL RD)",
        "titleCHI": "聖博德天主教小學（蒲崗村道）"
    },
    {
        "id": "-MFft42SHVvWvr8SF9Gw",
        "title": "ST PATRICK'S SCHOOL",
        "titleCHI": "聖博德學校"
    },
    {
        "id": "-MFft42SDFKBFlaQ6J2g",
        "title": "SKH KEI TAK PRIMARY SCHOOL",
        "titleCHI": "聖公會基德小學"
    },
    {
        "id": "-MFft42S7uoSk_XHL4vy",
        "title": "TSZ WAN SHAN CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "慈雲山天主教小學"
    },
    {
        "id": "-MFft42RnTpAqxwimwqf",
        "title": "PLK MRS CHAN NAM CHONG MEMORIAL PRI SCH",
        "titleCHI": "保良局陳南昌夫人小學"
    },
    {
        "id": "-MFft42RNsNFrxlyXpKe",
        "title": "PRICE MEMORIAL CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "天主教博智小學"
    },
    {
        "id": "-MFft42RBq5ysSjoClOX",
        "title": "PO YAN OBLATE PRIMARY SCHOOL",
        "titleCHI": "獻主會溥仁小學"
    },
    {
        "id": "-MFft42RAqT7fUJpT73n",
        "title": "NG WAH CATHOLIC PRI SCH",
        "titleCHI": "天主教伍華小學"
    },
    {
        "id": "-MFft42R33DXEWjxbJbZ",
        "title": "PLK GRANDMONT PRIMARY SCHOOL",
        "titleCHI": "保良局錦泰小學"
    },
    {
        "id": "-MFft42Qg2yc7IOecZpB",
        "title": "CHUN TOK SCHOOL",
        "titleCHI": "真鐸學校"
    },
    {
        "id": "-MFft42QRvbkzRo1xULS",
        "title": "HO LAP PRI SCH(SPSD BY SIK SIK YUEN)",
        "titleCHI": "嗇色園主辦可立小學"
    },
    {
        "id": "-MFft42QNyHExJjPVh8z",
        "title": "CONFUCIAN TAI SHING PRIMARY SCHOOL",
        "titleCHI": "孔教學院大成小學"
    },
    {
        "id": "-MFft42QKtnJF4IAx0ep",
        "title": "CHOI WAN ST JOSEPH'S PRIMARY SCHOOL",
        "titleCHI": "彩雲聖若瑟小學"
    },
    {
        "id": "-MFft42QJJEPQWRGsAZg",
        "title": "ISLAMIC DHARWOOD PAU MEMORIAL PRI SCH",
        "titleCHI": "伊斯蘭鮑伯濤紀念小學"
    },
    {
        "id": "-MFft42QG73iHf1WPbIw",
        "title": "CCC KEI WA PRIMARY SCHOOL",
        "titleCHI": "中華基督教會基華小學"
    },
    {
        "id": "-MFft42Pu6afILip7jVJ",
        "title": "CCC KEI TSZ PRIMARY SCHOOL",
        "titleCHI": "中華基督教會基慈小學"
    },
    {
        "id": "-MFft42Pt8XfI3XjzDeR",
        "title": "BISHOP FORD MEMORIAL SCHOOL",
        "titleCHI": "福德學校"
    },
    {
        "id": "-MFft42PMt3Kyv9_fqhB",
        "title": "CANOSSA PRIMARY SCHOOL (SAN PO KONG)",
        "titleCHI": "嘉諾撒小學（新蒲崗）"
    },
    {
        "id": "-MFft42PBE7NgwrE2_U0",
        "title": "CANOSSA PRIMARY SCHOOL",
        "titleCHI": "嘉諾撒小學"
    },
    {
        "id": "-MFft42P2-ksjlzDA6pB",
        "title": "BISHOP WALSH PRIMARY SCHOOL",
        "titleCHI": "華德學校"
    },
    {
        "id": "-MFft42OyrXbDsfl8kiz",
        "title": "TAK NGA PRIMARY SCHOOL",
        "titleCHI": "德雅小學"
    },
    {
        "id": "-MFft42OyayDxr00UHiw",
        "title": "TSUNG TSIN PRIMARY SCHOOL AND KG",
        "titleCHI": "崇真小學暨幼稚園"
    },
    {
        "id": "-MFft42OxWvmwfoDHEED",
        "title": "WONG TAI SIN GOVERNMENT PRIMARY SCH",
        "titleCHI": "黃大仙官立小學"
    },
    {
        "id": "-MFft42OVXy1Hc6MdJBc",
        "title": "SAN WUI COM SOC YMCA OF HK CHRISTIAN SCH",
        "titleCHI": "新會商會港青基信學校"
    },
    {
        "id": "-MFft42OG3I5XvLH2xqr",
        "title": "ST FRANCIS OF ASSISI'S ENGLISH PRI SCH",
        "titleCHI": "聖方濟各英文小學"
    },
    {
        "id": "-MFft42O25pwOtrnwXG5",
        "title": "BAPTIST RAINBOW PRIMARY SCHOOL",
        "titleCHI": "浸信會天虹小學"
    },
    {
        "id": "-MFft42NjC36nr-Klw3G",
        "title": "DELIA ENGLISH PRIMARY SCHOOL & KG",
        "titleCHI": "地利亞英文小學暨幼稚園"
    },
    {
        "id": "-MFft42NVRsH5H-UkV3y",
        "title": "YING WA PRIMARY SCHOOL",
        "titleCHI": "英華小學"
    },
    {
        "id": "-MFft42NUqFkyuuOnGDk",
        "title": "PO LEUNG KUK CHOI KAI YAU SCHOOL",
        "titleCHI": "保良局蔡繼有學校"
    },
    {
        "id": "-MFft42NScHHO2RCVoMa",
        "title": "CHAN'S CREATIVE SCHOOL",
        "titleCHI": "啓基學校"
    },
    {
        "id": "-MFft42NNBu14LFsEikT",
        "title": "CHRISTIAN ALLIANCE INTERNATIONAL SCHOOL",
        "titleCHI": "宣道國際學校"
    },
    {
        "id": "-MFft42MYo6Loc6Tz1bP",
        "title": "ST MARGARET'S CO-EDU ENG SEC & PRI SCH",
        "titleCHI": "聖瑪加利男女英文中小學"
    },
    {
        "id": "-MFft42MTPKtQ8ie5bwz",
        "title": "LINGNAN U ALUMNI ASSN (HK) PRIMARY SCH",
        "titleCHI": "嶺南大學香港同學會小學"
    },
    {
        "id": "-MFft42MNLfvhIXPcCtf",
        "title": "SSP KAIFONG WELFARE ASSN PRI SCH",
        "titleCHI": "深水埔街坊福利會小學"
    },
    {
        "id": "-MFft42MLbaqkrmHGiWh",
        "title": "ST FRANCIS OF ASSISI'S CARITAS SCHOOL",
        "titleCHI": "聖方濟愛德小學"
    },
    {
        "id": "-MFft42ME9WyOvM4H8qT",
        "title": "THE ELCHK FAITH LUTHERAN SCHOOL",
        "titleCHI": "基督教香港信義會深信學校"
    },
    {
        "id": "-MFft42M2T7SkeXd29ws",
        "title": "THE ELCHK FAITH LUTHERAN SCHOOL",
        "titleCHI": "基督教香港信義會深信學校"
    },
    {
        "id": "-MFft42L4l2bRyo7LvK6",
        "title": "SKH ST THOMAS' PRIMARY SCHOOL",
        "titleCHI": "聖公會聖多馬小學"
    },
    {
        "id": "-MFft42LxVoWLSc4-4x1",
        "title": "SKH KEI OI PRIMARY SCHOOL",
        "titleCHI": "聖公會基愛小學"
    },
    {
        "id": "-MFft42Lmk6fe14v5Bt_",
        "title": "MARYKNOLL FATHERS' SCH (PRI SECTION)",
        "titleCHI": "瑪利諾神父教會學校（小學部）"
    },
    {
        "id": "-MFft42LeGRsHd4GhXl_",
        "title": "SKH ST CLEMENT'S PRIMARY SCHOOL",
        "titleCHI": "聖公會聖紀文小學"
    },
    {
        "id": "-MFft42LUMY0rp0bn4pH",
        "title": "S.K.H. ST. ANDREW'S PRIMARY SCHOOL",
        "titleCHI": "聖公會聖安德烈小學"
    },
    {
        "id": "-MFft42LAf_h8yIahxK0",
        "title": "PAK TIN CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "白田天主教小學"
    },
    {
        "id": "-MFft42L-eg93ffTCT_c",
        "title": "S.K.H. KEI FOOK PRIMARY SCHOOL",
        "titleCHI": "聖公會基福小學"
    },
    {
        "id": "-MFft42Kplj7aMv7hFvP",
        "title": "HOI PING CHAMBER OF COMMERCE PRI SCH",
        "titleCHI": "旅港開平商會學校"
    },
    {
        "id": "-MFft42KiLZqJBuAh2Lx",
        "title": "FIVE DISTRICTS BUSINESS WEL ASSN SCH",
        "titleCHI": "五邑工商總會學校"
    },
    {
        "id": "-MFft42Khb948MJD5K3z",
        "title": "KA LING SCHOOL OF THE PRECIOUS BLOOD",
        "titleCHI": "寶血會嘉靈學校"
    },
    {
        "id": "-MFft42Kf67EStuEtsYZ",
        "title": "GOOD COUNSEL CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "天主教善導小學"
    },
    {
        "id": "-MFft42KevYDxt3_-xxi",
        "title": "LAICHIKOK CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "荔枝角天主教小學"
    },
    {
        "id": "-MFft42KaLOewKMe1N7M",
        "title": "HK SZE YAP C&IA SAN WUI COMM SOCIETY SCH",
        "titleCHI": "香港四邑商工總會新會商會學校"
    },
    {
        "id": "-MFft42K_6QXskArMi7_",
        "title": "CCC HEEP WOH PRI SCH (CHEUNG SHA WAN)",
        "titleCHI": "中華基督教會協和小學（長沙灣）"
    },
    {
        "id": "-MFft42Jn6hk41Eoy5Rr",
        "title": "ALLIANCE PRIMARY SCHOOL, TAI HANG TUNG",
        "titleCHI": "大坑東宣道小學"
    },
    {
        "id": "-MFft42J6ajPIqR6bU8k",
        "title": "SHAM SHUI PO GOVT PRI SCH",
        "titleCHI": "深水埗官立小學"
    },
    {
        "id": "-MFft42IxJtMVX2ZEthv",
        "title": "SHREWSBURY INT'L SCHOOL HK",
        "titleCHI": "思貝禮國際學校"
    },
    {
        "id": "-MFft42IkVspjEJMzKls",
        "title": "LI CHENG UK GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "李鄭屋官立小學"
    },
    {
        "id": "-MFft42Ij-Zjb4oFx_Ct",
        "title": "FUK WING STREET GOVERNMENT PRIM SCH",
        "titleCHI": "福榮街官立小學"
    },
    {
        "id": "-MFft42IgjB--JUz9bWj",
        "title": "HONG KONG ACADEMY",
        "titleCHI": "香港學堂國際學校"
    },
    {
        "id": "-MFft42IgBNg7yIlmwnH",
        "title": "LYC'EE FRANCAIS INTL (FRENCH INTL SCH)",
        "titleCHI": null
    },
    {
        "id": "-MFft42IWoY8jKCFw2ni",
        "title": "HONG KONG ADVENTIST ACADEMY",
        "titleCHI": "香港復臨學校"
    },
    {
        "id": "-MFft42HajMDmRNUjXek",
        "title": "CLEARWATER BAY SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft42H_XfXW8rZO-kp",
        "title": "G. T. (ELLEN YEUNG) COLLEGE",
        "titleCHI": "優才（楊殷有娣）書院"
    },
    {
        "id": "-MFft42HSQJD9-tDV7MQ",
        "title": "HKCCC UNION LOGOS ACADEMY",
        "titleCHI": "香港華人基督教聯會真道書院"
    },
    {
        "id": "-MFft42HR_r5jSVsW7X6",
        "title": "EVANGEL COLLEGE",
        "titleCHI": "播道書院"
    },
    {
        "id": "-MFft42HKC-FGFVunBBz",
        "title": "FOREST HOUSE WALDORF SCHOOL",
        "titleCHI": "樹宏學校"
    },
    {
        "id": "-MFft42HHzqnitKwYAGi",
        "title": "CLEARWATER BAY SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft42H33480QmtsGZT",
        "title": "PLK LUK HING TOO PRIMARY SCHOOL",
        "titleCHI": "保良局陸慶濤小學"
    },
    {
        "id": "-MFft42Gy3mPeT57oDPN",
        "title": "YCH CHAN IU SENG PRIMARY SCHOOL",
        "titleCHI": "仁濟醫院陳耀星小學"
    },
    {
        "id": "-MFft42Gx5s2shU59HUe",
        "title": "TWGH WONG YEE JAR JAT MEMORIAL PRI SCH",
        "titleCHI": "東華三院王余家潔紀念小學"
    },
    {
        "id": "-MFft42GwbXqPoUQwMBb",
        "title": "STFA LEUNG KIT WAH PRIMARY SCHOOL",
        "titleCHI": "順德聯誼總會梁潔華小學"
    },
    {
        "id": "-MFft42GsRsSLQa9r00p",
        "title": "TSEUNG KWAN O CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "將軍澳天主教小學"
    },
    {
        "id": "-MFft42GNu4jEFUMMTKi",
        "title": "TSEUNG KWAN O METHODIST PRIMARY SCHOOL",
        "titleCHI": "將軍澳循道衛理小學"
    },
    {
        "id": "-MFft42GGJRSHQKDYXAH",
        "title": "ST ANDREW'S CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "天主教聖安德肋小學"
    },
    {
        "id": "-MFft42G6BjCstoP5Vjd",
        "title": "YAN OI TONG TIN KA PING PRIMARY SCHOOL",
        "titleCHI": "仁愛堂田家炳小學"
    },
    {
        "id": "-MFft42Fnn3pER2BwiHz",
        "title": "SAI KUNG CENTRAL LEE SIU YAM MEM SCH",
        "titleCHI": "西貢中心李少欽紀念學校"
    },
    {
        "id": "-MFft42FeZJzoFBo05o0",
        "title": "PLK WONG WING SHU PRIMARY SCHOOL",
        "titleCHI": "保良局黃永樹小學"
    },
    {
        "id": "-MFft42FYhPkeK5bGV64",
        "title": "POK OI HOSPITAL CHAN KWOK WAI PRI SCH",
        "titleCHI": "博愛醫院陳國威小學"
    },
    {
        "id": "-MFft42FXQq02sx7jj5u",
        "title": "SAI KUNG SUNG TSUN CATH SCH (PRI SECT)",
        "titleCHI": "西貢崇真天主教學校（小學部）"
    },
    {
        "id": "-MFft42FQtXWU7qK32h1",
        "title": "S.K.H. TSEUNG KWAN O KEI TAK PRIMARY SCH",
        "titleCHI": "聖公會將軍澳基德小學"
    },
    {
        "id": "-MFft42Ey-piZwtQ7QsW",
        "title": "LOK SIN TONG LAU TAK PRIMARY SCHOOL",
        "titleCHI": "樂善堂劉德學校"
    },
    {
        "id": "-MFft42EwTdjOKPb5f-p",
        "title": "KING LAM CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "景林天主教小學"
    },
    {
        "id": "-MFft42Ed0yh9FKot2SL",
        "title": "KELLETT SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft42EW62uusZa1q3_",
        "title": "ST JOSEPH'S ANGLO-CHINESE PRIMARY SCHOOL",
        "titleCHI": "聖若瑟英文小學"
    },
    {
        "id": "-MFft42EE83haMngClmG",
        "title": "PLK FUNG CHING MEMORIAL PRIMARY SCHOOL",
        "titleCHI": "保良局馮晴紀念小學"
    },
    {
        "id": "-MFft42E-qlujJ0l_2HO",
        "title": "NORD ANGLIA INTERNATIONAL SCHOOL, HK",
        "titleCHI": null
    },
    {
        "id": "-MFft42Ds10v40vDJYXf",
        "title": "SKH TAK TIN LEE SHIU KEUNG PRIMARY SCH",
        "titleCHI": "聖公會德田李兆強小學"
    },
    {
        "id": "-MFft42DrOlF043i78d9",
        "title": "ST EDWARD'S CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "聖愛德華天主教小學"
    },
    {
        "id": "-MFft42DStiNpZJ5E7hO",
        "title": "ST JOHN THE BAPTIST CATH PRI SCH",
        "titleCHI": "聖若翰天主教小學"
    },
    {
        "id": "-MFft42DQu933fBjAhe0",
        "title": "FUKIEN SECONDARY SCHOOL AFFILIATED SCH",
        "titleCHI": "福建中學附屬學校"
    },
    {
        "id": "-MFft42DPN1yf-lUdbb6",
        "title": "ST MATTHEW'S LUTHERAN SCH (SAU MAU PING)",
        "titleCHI": "路德會聖馬太學校（秀茂坪）"
    },
    {
        "id": "-MFft42DMNcgncbZMdqx",
        "title": "ST ANTONIUS PRIMARY SCHOOL",
        "titleCHI": "聖安當小學"
    },
    {
        "id": "-MFft42D9tj7TvFjUJCN",
        "title": "DELIA SCHOOL OF CANADA (KOWLOON EAST)",
        "titleCHI": "地利亞（加拿大）學校－東九龍"
    },
    {
        "id": "-MFft42Crym83Jp-sRE2",
        "title": "SKH ST JOHN'S PRIMARY SCHOOL",
        "titleCHI": "聖公會聖約翰小學"
    },
    {
        "id": "-MFft42C_9fOw8mvAWPT",
        "title": "SKH KEI HIN PRIMARY SCHOOL",
        "titleCHI": "聖公會基顯小學"
    },
    {
        "id": "-MFft42CVGsNZ4JU9ClZ",
        "title": "SKH KEI LOK PRIMARY SCHOOL",
        "titleCHI": "聖公會基樂小學"
    },
    {
        "id": "-MFft42CUHKO9VFtoVRT",
        "title": "SKH LEE SHIU KEUNG PRIMARY SCHOOL",
        "titleCHI": "聖公會李兆強小學"
    },
    {
        "id": "-MFft42CJyiZcGKyKf-q",
        "title": "SAU MING PRIMARY SCHOOL",
        "titleCHI": "秀明小學"
    },
    {
        "id": "-MFft42CFpNmEekKPz3w",
        "title": "SAU MAU PING CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "秀茂坪天主教小學"
    },
    {
        "id": "-MFft42C2J2vk3yzljgN",
        "title": "SKH KOWLOON BAY KEI LOK PRIMARY SCHOOL",
        "titleCHI": "聖公會九龍灣基樂小學"
    },
    {
        "id": "-MFft42C1_6ELll8ay8H",
        "title": "S.K.H. YAUTONG KEI HIN PRIMARY SCHOOL",
        "titleCHI": "聖公會油塘基顯小學"
    },
    {
        "id": "-MFft42Bsl_Uhh5ciBek",
        "title": "LOK WAH CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "樂華天主教小學"
    },
    {
        "id": "-MFft42BLWQw3Q_JaVOB",
        "title": "OUR LADY OF CHINA CATHOLIC PRI SCH",
        "titleCHI": "天主教佑華小學"
    },
    {
        "id": "-MFft42BHIzlnq7vhfJu",
        "title": "PING SHEK ESTATE CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "坪石天主教小學"
    },
    {
        "id": "-MFft42BCtiarMBaj9Ft",
        "title": "MAN KIU ASSOCIATION PRIMARY SCHOOL",
        "titleCHI": "閩僑小學"
    },
    {
        "id": "-MFft42BACl9lXB8_iA-",
        "title": "MISSION COV CH HOLM GLAD NO.2 PRI SCH",
        "titleCHI": "基督教聖約教會堅樂第二小學"
    },
    {
        "id": "-MFft42B3DHdsCTO_o9W",
        "title": "MISSION COV CHURCH HOLM GLAD PRI SCH",
        "titleCHI": "基督教聖約教會堅樂小學"
    },
    {
        "id": "-MFft42Aehb8k01q-uZ-",
        "title": "KLN BAY ST JOHN THE BAPTIST CATH PRI SC",
        "titleCHI": "九龍灣聖若翰天主教小學"
    },
    {
        "id": "-MFft42AbLta5Rik0phS",
        "title": "JORDAN VALLEY ST JOSEPH'S CATHOLIC PS",
        "titleCHI": "佐敦谷聖若瑟天主教小學"
    },
    {
        "id": "-MFft42AYmQ5NV_HvGFv",
        "title": "HKTAYYI CHAN LUI CHUNG TAK MEMORIAL SCH",
        "titleCHI": "香港道教聯合會圓玄學院陳呂重德紀念學校"
    },
    {
        "id": "-MFft42ABjbEp5lcm2nq",
        "title": "LAM TIN METHODIST PRIMARY SCHOOL",
        "titleCHI": "藍田循道衛理小學"
    },
    {
        "id": "-MFft42A0kYiN3h6QMFW",
        "title": "LOK SIN TONG YEUNG CHUNG MING PRI SCH",
        "titleCHI": "樂善堂楊仲明學校"
    },
    {
        "id": "-MFft429UWSvPQONT6nm",
        "title": "HK TAOIST ASSOCIATION WUN TSUEN SCH",
        "titleCHI": "香港道教聯合會雲泉學校"
    },
    {
        "id": "-MFft429PJfVf3XQSpYH",
        "title": "CARMEL LEUNG SING TAK SCHOOL",
        "titleCHI": "迦密梁省德學校"
    },
    {
        "id": "-MFft429FPbAbrtt4d2A",
        "title": "CCC KEI FAAT PRIMARY SCHOOL (YAU TONG)",
        "titleCHI": "中華基督教會基法小學（油塘）"
    },
    {
        "id": "-MFft4298YPNhSOT3_GH",
        "title": "C&MA SUN KEI PRI SCH (PING SHEK)",
        "titleCHI": "基督教宣道會宣基小學（坪石）"
    },
    {
        "id": "-MFft4291B_cxp15J-u7",
        "title": "CONSERVATIVE BAPT LUI MING CHOI PRI SCH",
        "titleCHI": "浸信宣道會呂明才小學"
    },
    {
        "id": "-MFft4290aw24fOxUaSQ",
        "title": "CCC KEI FAAT PRIMARY SCHOOL",
        "titleCHI": "中華基督教會基法小學"
    },
    {
        "id": "-MFft428fYmojqlpMxKZ",
        "title": "KWUN TONG GOV PRI SCH (SAU MING ROAD)",
        "titleCHI": "觀塘官立小學〈秀明道〉"
    },
    {
        "id": "-MFft428fBu0-4BvZGpF",
        "title": "BUDDHIST CHI KING PRIMARY SCHOOL",
        "titleCHI": "佛教慈敬學校"
    },
    {
        "id": "-MFft428Vu7skEWfElqL",
        "title": "BISHOP PASCHANG CATHOLIC SCHOOL",
        "titleCHI": "天主教柏德學校"
    },
    {
        "id": "-MFft428PzNR0GWILbsM",
        "title": "KWUN TONG GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "觀塘官立小學"
    },
    {
        "id": "-MFft427wvvZzHa_6E6v",
        "title": "YEW CHUNG INTERNATIONAL SCHOOL",
        "titleCHI": "耀中國際學校"
    },
    {
        "id": "-MFft427_OcfGJtuQmHK",
        "title": "STAMFORD AMERICAN SCHOOL HONG KONG",
        "titleCHI": null
    },
    {
        "id": "-MFft427VIGYxIUD09ST",
        "title": "YEW CHUNG INTERNATIONAL SCHOOL",
        "titleCHI": "耀中國際學校"
    },
    {
        "id": "-MFft427BBfRjGEkY-jc",
        "title": "THINK INTERNATIONAL SCHOOL",
        "titleCHI": "朗思國際學校"
    },
    {
        "id": "-MFft4276INCtbHwZHM8",
        "title": "YEW CHUNG INTERNATIONAL SCHOOL",
        "titleCHI": "耀中國際學校"
    },
    {
        "id": "-MFft426bUr61Hspj7e8",
        "title": "KOWLOON TRUE LIGHT SCH (PRIMARY SECTION)",
        "titleCHI": "九龍真光中學（小學部）"
    },
    {
        "id": "-MFft426Rku9eQ11unYc",
        "title": "POOI TO PRIMARY SCHOOL",
        "titleCHI": "香港培道小學"
    },
    {
        "id": "-MFft426JTUm4U_v5o8f",
        "title": "ST JOHANNES COLLEGE",
        "titleCHI": "聖若望英文書院"
    },
    {
        "id": "-MFft426JLFKSwYwn482",
        "title": "MUNSANG COLLEGE PRIMARY SCHOOL",
        "titleCHI": "民生書院小學"
    },
    {
        "id": "-MFft4269A91jCX7myi7",
        "title": "PUI CHING PRIMARY SCHOOL",
        "titleCHI": "香港培正小學"
    },
    {
        "id": "-MFft4260zCeQphqT_5U",
        "title": "PLK MADAM CHAN WAI CHOW MEMORIAL SCH",
        "titleCHI": "保良局陳維周夫人紀念學校"
    },
    {
        "id": "-MFft425_rjTYn8kPQZ3",
        "title": "HOLY TRINITY PRIMARY SCHOOL",
        "titleCHI": "聖三一堂小學"
    },
    {
        "id": "-MFft425DGu5gqDu2oje",
        "title": "KINGSTON INTERNATIONAL SCHOOL",
        "titleCHI": "京斯敦國際學校"
    },
    {
        "id": "-MFft425CwUOQucwXeXU",
        "title": "KLT FUNFUL ENGLISH PRIMARY SCHOOL",
        "titleCHI": "九龍塘方方樂趣英文小學"
    },
    {
        "id": "-MFft42538k_yidN5M7W",
        "title": "KOWLOON TONG SCHOOL",
        "titleCHI": "九龍塘學校"
    },
    {
        "id": "-MFft424wng0v66Codyw",
        "title": "AMERICAN INTERNATIONAL SCH (PRI BRANCH)",
        "titleCHI": null
    },
    {
        "id": "-MFft424rMjM_8Ca3hc9",
        "title": "AMERICAN INTERNATIONAL SCHOOL",
        "titleCHI": "美國國際學校"
    },
    {
        "id": "-MFft424koRCAcA6HS3-",
        "title": "CREATIVE PRIMARY SCHOOL",
        "titleCHI": "啓思小學"
    },
    {
        "id": "-MFft424Z2mEagGLBNdr",
        "title": "AUSTRALIAN INTERNATIONAL SCH HK",
        "titleCHI": "香港澳洲國際學校"
    },
    {
        "id": "-MFft424POQw1fdre1bc",
        "title": "FIRST ASSEMBLY OF GOD PRI SCH & KG",
        "titleCHI": "神召第一小學暨幼稚園"
    },
    {
        "id": "-MFft424A67GeysweQLi",
        "title": "AOI PUI SCHOOL",
        "titleCHI": "愛培學校"
    },
    {
        "id": "-MFft423y1abYngq2e_C",
        "title": "BEACON HILL SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft423hj61WaC9YFG9",
        "title": "PLK LAM MAN CHAN ENGLISH PRI SCH",
        "titleCHI": "保良局林文燦英文小學"
    },
    {
        "id": "-MFft423c69TTrcF2pf9",
        "title": "KOWLOON JUNIOR SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft423PqcbN3V4QedG",
        "title": "ST ROSE OF LIMA'S SCHOOL",
        "titleCHI": "聖羅撒學校"
    },
    {
        "id": "-MFft423I4bFoN_ZdEIY",
        "title": "PLK LAM MAN CHAN ENGLISH PRI SCH",
        "titleCHI": "保良局林文燦英文小學"
    },
    {
        "id": "-MFft423FFZ_cFfQzf_M",
        "title": "ALLIANCE PRIMARY SCHOOL KOWLOON TONG",
        "titleCHI": "九龍塘宣道小學"
    },
    {
        "id": "-MFft4236_QDyoB3jdJn",
        "title": "DIOCESAN BOYS' SCHOOL",
        "titleCHI": "拔萃男書院"
    },
    {
        "id": "-MFft422pVSNdaF6SSbt",
        "title": "ST EUGENE DE MAZENOD OBLATE PRIMARY SCH",
        "titleCHI": "獻主會聖馬善樂小學"
    },
    {
        "id": "-MFft422h4OOekB9Gtgl",
        "title": "SKH FUNG KEI PRIMARY SCHOOL",
        "titleCHI": "聖公會奉基小學"
    },
    {
        "id": "-MFft422fx9ghFOoNF_T",
        "title": "SKH GOOD SHEPHERD PRIMARY SCHOOL",
        "titleCHI": "聖公會牧愛小學"
    },
    {
        "id": "-MFft422eBn8gRrV4IyF",
        "title": "S.K.H. HOLY CARPENTER PRIMARY SCHOOL",
        "titleCHI": "聖公會聖匠小學"
    },
    {
        "id": "-MFft4229oclNwJec3Am",
        "title": "SKH FUNG KEI MILLENNIUM PRI SCH",
        "titleCHI": "聖公會奉基千禧小學"
    },
    {
        "id": "-MFft4229DLkqJZjAYZn",
        "title": "SKH ST TIMOTHY'S PRIMARY SCHOOL",
        "titleCHI": "聖公會聖提摩太小學"
    },
    {
        "id": "-MFft4222dsCGDwkFpCd",
        "title": "SKH HOLY CROSS PRIMARY SCHOOL",
        "titleCHI": "聖公會聖十架小學"
    },
    {
        "id": "-MFft421yZlnOi-AWzA-",
        "title": "LING TO CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "天主教領島學校"
    },
    {
        "id": "-MFft421sjjBoXY41-RV",
        "title": "PLK STANLEY HO SAU NAN PRIMARY SCHOOL",
        "titleCHI": "保良局何壽南小學"
    },
    {
        "id": "-MFft421sFDe3bJmdoSe",
        "title": "OBLATE PRIMARY SCHOOL",
        "titleCHI": "獻主會小學"
    },
    {
        "id": "-MFft421JDsjmx9RbMFP",
        "title": "MARYKNOLL CONVENT SCH (PRI SECT)",
        "titleCHI": "瑪利諾修院學校（小學部）"
    },
    {
        "id": "-MFft421Eh7rM3dE4bIS",
        "title": "KOWLOON TONG BISHOP WALSH CATHOLIC SCH",
        "titleCHI": "九龍塘天主教華德學校"
    },
    {
        "id": "-MFft4218tWHYI9dPob_",
        "title": "LOK SIN TONG PRIMARY SCHOOL",
        "titleCHI": "樂善堂小學"
    },
    {
        "id": "-MFft4215Iir9KTVO7iy",
        "title": "IU SHAN SCHOOL",
        "titleCHI": "耀山學校"
    },
    {
        "id": "-MFft4210XXFz0-H0rTb",
        "title": "LA SALLE PRIMARY SCHOOL",
        "titleCHI": "喇沙小學"
    },
    {
        "id": "-MFft420pj9z7Av3Q03G",
        "title": "HOLY FAMILY CANOSSIAN SCH (KLN TONG)",
        "titleCHI": "嘉諾撒聖家學校（九龍塘）"
    },
    {
        "id": "-MFft420_nk-2YVWwavL",
        "title": "HOLY ANGELS CANOSSIAN SCHOOL",
        "titleCHI": "天神嘉諾撒學校"
    },
    {
        "id": "-MFft420IWG6Cwtef2_U",
        "title": "GCEPSA WHAMPOA PRIMARY SCHOOL",
        "titleCHI": "葛量洪校友會黃埔學校"
    },
    {
        "id": "-MFft420FSkyMUFE6RfE",
        "title": "HEEP YUNN PRIMARY SCHOOL",
        "titleCHI": "協恩中學附屬小學"
    },
    {
        "id": "-MFft420FB-1_s-QrFlA",
        "title": "HOP YAT CHURCH SCHOOL",
        "titleCHI": "合一堂學校"
    },
    {
        "id": "-MFft420Cfb_5sj-RBGC",
        "title": "HOP YAT CHURCH SCHOOL",
        "titleCHI": "合一堂學校"
    },
    {
        "id": "-MFft4206g5XVxZGaDST",
        "title": "HOLY FAMILY CANOSSIAN SCHOOL",
        "titleCHI": "嘉諾撒聖家學校"
    },
    {
        "id": "-MFft42-pK3NB_koZr7U",
        "title": "DIOCESAN PREPARATORY SCHOOL",
        "titleCHI": "拔萃小學"
    },
    {
        "id": "-MFft42-fxY0S-bNSb_t",
        "title": "CHAN SUI KI (LA SALLE) PRIMARY SCHOOL",
        "titleCHI": "陳瑞祺（喇沙）小學"
    },
    {
        "id": "-MFft42-IRWK2_fZEVob",
        "title": "EMMANUEL PRIMARY SCHOOL, KOWLOON",
        "titleCHI": "九龍靈光小學"
    },
    {
        "id": "-MFft42-DAHVbLmuU1nX",
        "title": "CCC WANCHAI CHURCH KEI TO PS (KLN CITY)",
        "titleCHI": "中華基督教會灣仔堂基道小學（九龍城）"
    },
    {
        "id": "-MFft42-88e009YdH18n",
        "title": "ELCHK HUNG HOM LUTHERAN PRIMARY SCHOOL",
        "titleCHI": "基督教香港信義會紅磡信義學校"
    },
    {
        "id": "-MFft41zXZ2-e88_9OxE",
        "title": "MA TAU CHUNG GOVT PRI SCH (HUNG HOM BAY)",
        "titleCHI": "馬頭涌官立小學（紅磡灣）"
    },
    {
        "id": "-MFft41zUgP1K4EJISrR",
        "title": "CCC KEI WA PRI SCH (KOWLOON TONG)",
        "titleCHI": "中華基督教會基華小學（九龍塘）"
    },
    {
        "id": "-MFft41zHie88cJbEu-C",
        "title": "MA TAU CHUNG GOVERNMENT PRIMARY SCH",
        "titleCHI": "馬頭涌官立小學"
    },
    {
        "id": "-MFft41zC2gxL5q5t-cF",
        "title": "KOWLOON TONG GOVERNMENT PRI SCH",
        "titleCHI": "九龍塘官立小學"
    },
    {
        "id": "-MFft41z9gx-AVH0ythD",
        "title": "ALLIANCE PRIMARY SCHOOL,WHAMPOA",
        "titleCHI": "黃埔宣道小學"
    },
    {
        "id": "-MFft41yiErvfSlxjvOp",
        "title": "RAIMONDI COLLEGE PRIMARY SECTION",
        "titleCHI": "高主教書院小學部"
    },
    {
        "id": "-MFft41ycnWsrb0b-Hp4",
        "title": "FARM ROAD GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "農圃道官立小學"
    },
    {
        "id": "-MFft41yWNilnME7B2T6",
        "title": "TRUE LIGHT MIDDLE SCHOOL OF HONG KONG",
        "titleCHI": "香港真光中學"
    },
    {
        "id": "-MFft41yV8Y1AidgDezo",
        "title": "ROSARYHILL SCHOOL",
        "titleCHI": "玫瑰崗學校"
    },
    {
        "id": "-MFft41yDdvlamtFfGaO",
        "title": "ST PAUL'S CONVENT SCH (PRI SECTION)",
        "titleCHI": "聖保祿學校（小學部）"
    },
    {
        "id": "-MFft41yD7ykNS_rHw-q",
        "title": "LYC'EE FRANCAIS INTL (FRENCH INTL SCH)",
        "titleCHI": null
    },
    {
        "id": "-MFft41xr4oRtzpAwzrC",
        "title": "HONGKONG JAPANESE SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft41xpg9k-Ywo0S41",
        "title": "CHINESE ACADEMY",
        "titleCHI": "晉德學校"
    },
    {
        "id": "-MFft41xmIkny_S3m0zw",
        "title": "HKCA PO LEUNG KUK SCHOOL",
        "titleCHI": "保良局建造商會學校"
    },
    {
        "id": "-MFft41xQo6skdI2S5Vx",
        "title": "TWGH LI CHI HO PRIMARY SCHOOL",
        "titleCHI": "東華三院李賜豪小學"
    },
    {
        "id": "-MFft41xMtMJHzSY3xCY",
        "title": "ST PAUL'S PRIMARY CATHOLIC SCHOOL",
        "titleCHI": "聖保祿天主教小學"
    },
    {
        "id": "-MFft41x6LwXW7IpQntq",
        "title": "BRADBURY SCHOOL",
        "titleCHI": "白普理小學"
    },
    {
        "id": "-MFft41wksTC7VmxOdqp",
        "title": "SKH ST JAMES' PRIMARY SCHOOL",
        "titleCHI": "聖公會聖雅各小學"
    },
    {
        "id": "-MFft41wQuHtLVQtw0ZM",
        "title": "ST JOSEPH'S PRIMARY SCHOOL",
        "titleCHI": "聖若瑟小學"
    },
    {
        "id": "-MFft41wLK3qfeY_kSV1",
        "title": "PUN U ASSOCIATION WAH YAN PRIMARY SCHOOL",
        "titleCHI": "番禺會所華仁小學"
    },
    {
        "id": "-MFft41wIVfytq7vw1uY",
        "title": "PUN U ASSOCIATION WAH YAN PRIMARY SCHOOL",
        "titleCHI": "番禺會所華仁小學"
    },
    {
        "id": "-MFft41w0S8_-y12RvF4",
        "title": "ST FRANCIS' CANOSSIAN SCHOOL",
        "titleCHI": "嘉諾撒聖方濟各學校"
    },
    {
        "id": "-MFft41voCZxrBoPPGBq",
        "title": "PRECIOUS BLOOD PRIMARY SCHOOL",
        "titleCHI": "寶血小學"
    },
    {
        "id": "-MFft41vw9HtCtn9xPGK",
        "title": "LI SING TAI HANG SCHOOL",
        "titleCHI": "李陞大坑學校"
    },
    {
        "id": "-MFft41vd39Oqy4QjV6D",
        "title": "PO KOK PRIMARY SCHOOL",
        "titleCHI": "寶覺小學"
    },
    {
        "id": "-MFft41vbNnal2Bju5ux",
        "title": "PLK G & S ES PERSHING TSANG SCHOOL",
        "titleCHI": "保良局金銀業貿易場張凝文學校"
    },
    {
        "id": "-MFft41vab70Psxx7jjR",
        "title": "BUDDHIST WONG CHEUK UM PRIMARY SCHOOL",
        "titleCHI": "佛教黃焯菴小學"
    },
    {
        "id": "-MFft41vEdvNmyeWSQUf",
        "title": "MARYMOUNT PRIMARY SCHOOL",
        "titleCHI": "瑪利曼小學"
    },
    {
        "id": "-MFft41uhFCb4-2Mp46Z",
        "title": "HENNESSY RD GOVT PRI SCH (CAUSEWAY BAY)",
        "titleCHI": "軒尼詩道官立小學（銅鑼灣）"
    },
    {
        "id": "-MFft41uQbenUm7hH0ly",
        "title": "WYCOMBE ABBEY SCHOOL HONG KONG",
        "titleCHI": "香港威雅學校"
    },
    {
        "id": "-MFft41uQAXRWOlfMvcR",
        "title": "SIR ELLIS KADOORIE (SOOKUNPO) PRI SCH",
        "titleCHI": "官立嘉道理爵士小學"
    },
    {
        "id": "-MFft41uICdWFhg-ExQG",
        "title": "VICTORIA SHANGHAI ACADEMY",
        "titleCHI": "滬江維多利亞學校"
    },
    {
        "id": "-MFft41uBrqMw4ZYDxgP",
        "title": "HENNESSY ROAD GOVERNMENT PRIMARY SCH",
        "titleCHI": "軒尼詩道官立小學"
    },
    {
        "id": "-MFft41u6n9ETISjZa4j",
        "title": "NORTH POINT GOVT PRI SCH (CLOUD VIEW RD)",
        "titleCHI": "北角官立小學（雲景道）"
    },
    {
        "id": "-MFft41txQEPrUSxeMb9",
        "title": "KELLETT SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft41tlBAJFD-YOha8",
        "title": "THE HARBOUR SCHOOL",
        "titleCHI": "港灣學校"
    },
    {
        "id": "-MFft41taWLe8FLrrDxD",
        "title": "ST STEPHEN'S COLLEGE PREPARATORY SCHOOL",
        "titleCHI": "聖士提反書院附屬小學"
    },
    {
        "id": "-MFft41tFb1YcZRDfd7_",
        "title": "SINGAPORE INTERNATIONAL SCH (HONG KONG)",
        "titleCHI": "新加坡國際學校"
    },
    {
        "id": "-MFft41tEbe4wpwrdesb",
        "title": "THE HARBOUR SCHOOL",
        "titleCHI": "港灣學校"
    },
    {
        "id": "-MFft41t9LUQQtIDGmhg",
        "title": "INTERNATIONAL MONTESSORI SCH - AN IMEF",
        "titleCHI": "蒙特梭利國際學校"
    },
    {
        "id": "-MFft41sylHUhD_cFHe2",
        "title": "HAN ACADEMY",
        "titleCHI": "漢鼎書院"
    },
    {
        "id": "-MFft41ss1doAqYnfnh5",
        "title": "GERMAN SWISS INTERNATIONAL SCHOOL",
        "titleCHI": "德瑞國際學校"
    },
    {
        "id": "-MFft41srn1e0etO-Uzs",
        "title": "HONG KONG INTERNATIONAL SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft41s0gFm5rxoJoVM",
        "title": "INDEPENDENT SCHOOLS FOUNDATION ACADEMY",
        "titleCHI": "弘立書院"
    },
    {
        "id": "-MFft41s0aRvxjzfslhA",
        "title": "CANADIAN INTERNATIONAL SCHOOL",
        "titleCHI": "加拿大國際學校"
    },
    {
        "id": "-MFft41rlJGnpcPFYgZk",
        "title": "TWGH HOK SHAN SCHOOL",
        "titleCHI": "東華三院鶴山學校"
    },
    {
        "id": "-MFft41rco1PDbL3RQMR",
        "title": "ST PAUL'S COLLEGE PRIMARY SCHOOL",
        "titleCHI": "聖保羅書院小學"
    },
    {
        "id": "-MFft41rMN_tXA53uEkc",
        "title": "ST PAUL'S CO-EDU COLLEGE PRI SCH",
        "titleCHI": "聖保羅男女中學附屬小學"
    },
    {
        "id": "-MFft41rGtfOHpmO9yHg",
        "title": "KENNEDY SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft41r20EuClaLDU0J",
        "title": "ST PETER'S CATHOLIC PRIMARY SCHOOL",
        "titleCHI": "聖伯多祿天主教小學"
    },
    {
        "id": "-MFft41qxBSkfCDmqhBX",
        "title": "PUI TAK CANOSSIAN PRIMARY SCHOOL",
        "titleCHI": "嘉諾撒培德學校"
    },
    {
        "id": "-MFft41qsB3Cb8AzFtxk",
        "title": "SKH CHI FU CHI NAM PRIMARY SCHOOL",
        "titleCHI": "聖公會置富始南小學"
    },
    {
        "id": "-MFft41qosbdhKKzCGqU",
        "title": "PRECIOUS BLOOD PRI SCH (SOUTH HORIZONS)",
        "titleCHI": "海怡寶血小學"
    },
    {
        "id": "-MFft41qiQEHXLTONvmA",
        "title": "SKH TIN WAN CHI NAM PRIMARY SCHOOL",
        "titleCHI": "聖公會田灣始南小學"
    },
    {
        "id": "-MFft41q1Vns5P9jbJFA",
        "title": "PRECIOUS BLOOD PRI SCH (WAH FU ESTATE)",
        "titleCHI": "華富邨寶血小學"
    },
    {
        "id": "-MFft41pFIE8Hspn-v3c",
        "title": "APLICHAU KAIFONG PRIMARY SCHOOL",
        "titleCHI": "鴨脷洲街坊學校"
    },
    {
        "id": "-MFft41pyWW4KVCLLOGC",
        "title": "SACRED HEART CANOSSIAN SCH, PRIVATE SECT",
        "titleCHI": "嘉諾撒聖心學校私立部"
    },
    {
        "id": "-MFft41pM9Do2r-IA3LI",
        "title": "ISLAND ROAD GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "香島道官立小學"
    },
    {
        "id": "-MFft41pLp4-1RRoiZr0",
        "title": "HONG KONG SOUTHERN DISTRICT GOVT PRI SCH",
        "titleCHI": "香港南區官立小學"
    },
    {
        "id": "-MFft41p7ds5vPFokOzp",
        "title": "ST CLARE'S PRIMARY SCHOOL",
        "titleCHI": "聖嘉勒小學"
    },
    {
        "id": "-MFft41p5ReU_JhKPmnL",
        "title": "ABERDEEN ST PETER'S CATHOLIC PRIMARY SCH",
        "titleCHI": "香港仔聖伯多祿天主教小學"
    },
    {
        "id": "-MFft41p3E0hs9N2bbh5",
        "title": "ST. LOUIS SCHOOL (PRIMARY SECTION)",
        "titleCHI": "聖類斯中學（小學部）"
    },
    {
        "id": "-MFft41ou30vITs3QnTq",
        "title": "PEAK SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft41os_YbTDtIwi7j",
        "title": "CARMEL SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft41oiqWDQJoYix5L",
        "title": "KAU YAN SCHOOL",
        "titleCHI": "救恩學校"
    },
    {
        "id": "-MFft41oQrQvg7p-3R0M",
        "title": "ISLAND WALDORF SCHOOL",
        "titleCHI": "香島華德福學校"
    },
    {
        "id": "-MFft41oKf7dfEtfmENR",
        "title": "GERMAN SWISS INTERNATIONAL SCHOOL",
        "titleCHI": "德瑞國際學校"
    },
    {
        "id": "-MFft41oGjXvbhj0_GkV",
        "title": "ST STEPHEN'S GIRLS' PRIMARY SCHOOL",
        "titleCHI": "聖士提反女子中學附屬小學"
    },
    {
        "id": "-MFft41oAbm_c_hAw6ab",
        "title": "GLENEALY SCHOOL",
        "titleCHI": "己連拿小學"
    },
    {
        "id": "-MFft41o3vMe-fD8mRI2",
        "title": "ISLAND CHRISTIAN ACADEMY",
        "titleCHI": null
    },
    {
        "id": "-MFft41njNp7wHfFqURO",
        "title": "ST ANTHONY'S SCHOOL",
        "titleCHI": "聖安多尼學校"
    },
    {
        "id": "-MFft41ngzZ4WQMtcDxD",
        "title": "SKH LUI MING CHOI MEMORIAL PRI SCH",
        "titleCHI": "聖公會呂明才紀念小學"
    },
    {
        "id": "-MFft41ndRRHZMIlDTkw",
        "title": "SKH ST PETER'S PRIMARY SCHOOL",
        "titleCHI": "聖公會聖彼得小學"
    },
    {
        "id": "-MFft41nY_S8Ne2EXER1",
        "title": "SKH ST MATTHEW'S PRIMARY SCHOOL",
        "titleCHI": "聖公會聖馬太小學"
    },
    {
        "id": "-MFft41nYJa1H4AB3iUC",
        "title": "ST CHARLES SCHOOL",
        "titleCHI": "聖嘉祿學校"
    },
    {
        "id": "-MFft41n8lasTChXaiUM",
        "title": "SKH KEI YAN PRIMARY SCHOOL",
        "titleCHI": "聖公會基恩小學"
    },
    {
        "id": "-MFft41n4e7QtQEVvzN2",
        "title": "SAN WUI COMMERCIAL SOCIETY SCHOOL",
        "titleCHI": "新會商會學校"
    },
    {
        "id": "-MFft41mvCVBtvMvFroQ",
        "title": "CENTRAL & WESTERN DIST ST ANTHONY'S SCH",
        "titleCHI": "中西區聖安多尼學校"
    },
    {
        "id": "-MFft41mtC9hvbRLEQ2O",
        "title": "KING'S COLL OLD BOYS' ASSN PRI SCH",
        "titleCHI": "英皇書院同學會小學"
    },
    {
        "id": "-MFft41mdObbBSrXvwgF",
        "title": "SACRED HEART CANOSSIAN SCHOOL",
        "titleCHI": "嘉諾撒聖心學校"
    },
    {
        "id": "-MFft41mIgh-DOHuqyco",
        "title": "CHIU SHEUNG SCHOOL, HONG KONG",
        "titleCHI": "香港潮商學校"
    },
    {
        "id": "-MFft41mF26v4wvwK3gC",
        "title": "CATHOLIC MISSION SCHOOL",
        "titleCHI": "天主教總堂區學校"
    },
    {
        "id": "-MFft41m5l-1mpSEIb9Z",
        "title": "KING'S COLL OLD BOYS' ASSN PRI SCH NO. 2",
        "titleCHI": "英皇書院同學會小學第二校"
    },
    {
        "id": "-MFft41lsID7zp03TAvG",
        "title": "KOREAN INTERNATIONAL SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft41lk8OVdhC0s5BU",
        "title": "LYC'EE FRANCAIS INTL (FRENCH INTL SCH)",
        "titleCHI": null
    },
    {
        "id": "-MFft41lgAT2wWTkMiMn",
        "title": "KIANGSU & CHEKIANG PRIMARY SCHOOL",
        "titleCHI": "蘇浙小學校"
    },
    {
        "id": "-MFft41lbnXmuOXaL2eF",
        "title": "BONHAM RD GOVERNMENT PRI SCH",
        "titleCHI": "般咸道官立小學"
    },
    {
        "id": "-MFft41lEnsHSizuBifw",
        "title": "GRACE CHRISTIAN ACADEMY",
        "titleCHI": "培生學校"
    },
    {
        "id": "-MFft41l6szkxKXwppJa",
        "title": "LI SING PRIMARY SCHOOL",
        "titleCHI": "李陞小學"
    },
    {
        "id": "-MFft41l6QTrYUaQDhV0",
        "title": "KIANGSU & CHEKIANG PRIMARY SCHOOL",
        "titleCHI": "蘇浙小學校"
    },
    {
        "id": "-MFft41kwI9RbV7G0VlX",
        "title": "CARMEL SCHOOL",
        "titleCHI": null
    },
    {
        "id": "-MFft41kf4KK1SSEiOjs",
        "title": "CHINESE INTERNATIONAL SCHOOL",
        "titleCHI": "漢基國際學校"
    },
    {
        "id": "-MFft41kNqHyvLmtOPOH",
        "title": "TAIKOO PRIMARY SCHOOL",
        "titleCHI": "太古小學"
    },
    {
        "id": "-MFft41kNe8C-e3pxSAJ",
        "title": "HON WAH COLLEGE",
        "titleCHI": "漢華中學"
    },
    {
        "id": "-MFft41kNJp-8mh8yDew",
        "title": "QUARRY BAY  SCHOOL",
        "titleCHI": "鰂魚涌小學"
    },
    {
        "id": "-MFft41kBwKUIn6MrvGN",
        "title": "HKUGA PRIMARY SCHOOL",
        "titleCHI": "港大同學會小學"
    },
    {
        "id": "-MFft41k8vJAmAhR8rol",
        "title": "DELIA SCHOOL OF CANADA",
        "titleCHI": "地利亞（加拿大）學校"
    },
    {
        "id": "-MFft41k89AXYbRgKk-W",
        "title": "ST. MARK'S PRIMARY SCHOOL",
        "titleCHI": "聖馬可小學"
    },
    {
        "id": "-MFft41jz5ERx9WpCXFN",
        "title": "SHAUKIWAN TSUNG TSIN SCHOOL",
        "titleCHI": "筲箕灣崇真學校"
    },
    {
        "id": "-MFft41jjCTtt6eUHVIk",
        "title": "SALVATION ARMY CENTALINE CHARITY FUND SC",
        "titleCHI": "救世軍中原慈善基金學校"
    },
    {
        "id": "-MFft41jgOOimJy50h_n",
        "title": "SALESIAN SCHOOL",
        "titleCHI": "慈幼學校"
    },
    {
        "id": "-MFft41jZZbADlhvCAQC",
        "title": "S.K.H. CHAI WAN ST. MICHAEL'S PRI SCH",
        "titleCHI": "聖公會柴灣聖米迦勒小學"
    },
    {
        "id": "-MFft41jSf0w9Mkrua2A",
        "title": "SA ANN WYLLIE MEMORIAL SCHOOL",
        "titleCHI": "救世軍韋理夫人紀念學校"
    },
    {
        "id": "-MFft41jHiPodXhabqIZ",
        "title": "SHANGHAI ALUMNI PRIMARY SCHOOL",
        "titleCHI": "滬江小學"
    },
    {
        "id": "-MFft41jEq8hpPbx7Tpu",
        "title": "SKH ST MICHAEL'S PRIMARY SCHOOL",
        "titleCHI": "聖公會聖米迦勒小學"
    },
    {
        "id": "-MFft41iu7hLhnjXPDS-",
        "title": "PUI KIU PRIMARY SCHOOL",
        "titleCHI": "培僑小學"
    },
    {
        "id": "-MFft41isVNwJ69mxVtA",
        "title": "NORTH POINT METHODIST PRIMARY SCHOOL",
        "titleCHI": "北角衞理小學"
    },
    {
        "id": "-MFft41ifskQHwt5KJhE",
        "title": "ENDEAVR LEUNG LEE SAU YU MEM PRI SCH",
        "titleCHI": "勵志會梁李秀娛紀念小學"
    },
    {
        "id": "-MFft41iNAvCox6eFOcM",
        "title": "CHINESE METHODIST SCHOOL (NORTH POINT)",
        "titleCHI": "北角循道學校"
    },
    {
        "id": "-MFft41iKOi-b_tQ0hT6",
        "title": "HKCWC HIOE TJO YOENG PRI SCH",
        "titleCHI": "香港中國婦女會丘佐榮學校"
    },
    {
        "id": "-MFft41i3EuK6kcCszb1",
        "title": "MENG TAK CATHOLIC SCHOOL",
        "titleCHI": "天主教明德學校"
    },
    {
        "id": "-MFft41i0wa9EZwxNx4i",
        "title": "ELCHK FAITH LOVE LUTHERAN SCHOOL",
        "titleCHI": "基督教香港信義會信愛學校"
    },
    {
        "id": "-MFft41i0bVD-jJuFpBn",
        "title": "CHINESE METHODIST SCHOOL, TANNER HILL",
        "titleCHI": "丹拿山循道學校"
    },
    {
        "id": "-MFft41hqM1-tehwWQt3",
        "title": "CHAN'S CREATIVE SCHOOL (HONG KONG ISLAND",
        "titleCHI": "啓基學校（港島）"
    },
    {
        "id": "-MFft41hUSM7yAB6GkKf",
        "title": "CCC KEI WAN PRIMARY SCHOOL (ALDRICH BAY)",
        "titleCHI": "中華基督教會基灣小學（愛蝶灣）"
    },
    {
        "id": "-MFft41hKdFwa1K8S7gH",
        "title": "BUDDHIST CHUNG WAH KORNHILL PRI SCH",
        "titleCHI": "佛教中華康山學校"
    },
    {
        "id": "-MFft41hGsICjAlB4YZz",
        "title": "CCC KEI WAN PRIMARY SCHOOL",
        "titleCHI": "中華基督教會基灣小學"
    },
    {
        "id": "-MFft41hDihfPJQuv9RP",
        "title": "CANOSSA SCHOOL (HONG KONG)",
        "titleCHI": "香港嘉諾撒學校"
    },
    {
        "id": "-MFft41h0cDzqjGs_mJ8",
        "title": "SHAU KEI WAN GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "筲箕灣官立小學"
    },
    {
        "id": "-MFft41gqhM3JkaJ0ALl",
        "title": "ALDRICH BAY GOVERNMENT PRI SCH",
        "titleCHI": "愛秩序灣官立小學"
    },
    {
        "id": "-MFft41gAJy7cYjv9hAN",
        "title": "NORTH POINT GOVERNMENT PRIMARY SCHOOL",
        "titleCHI": "北角官立小學"
    },
    {
        "id": "-MFfj-6rymjdCcHwm4S2",
        "title": "CNEC CHRISTIAN COLLEGE",
        "titleCHI": "中華傳道會安柱中學"
    },
    {
        "id": "-MFfj-6ry9UZKZ-YrL83",
        "title": "GOOD HOPE SCHOOL",
        "titleCHI": "德望學校"
    },
    {
        "id": "-MFfj-6rxwI-u6Vz6XYw",
        "title": "KING LING COLLEGE",
        "titleCHI": "景嶺書院"
    },
    {
        "id": "-MFfj-6rxflCyVDIIeo-",
        "title": "HKTA The Yuen Yuen Institute No.1 Secondary School",
        "titleCHI": "圓玄學院第一中學"
    },
    {
        "id": "-MFfj-6rxWmMJ2644feQ",
        "title": "BUDDHIST HUNG SEAN CHAU MEMORIAL COLLEGE",
        "titleCHI": "佛教孔仙洲紀念中學"
    },
    {
        "id": "-MFfj-6rwl1G2aD-G7S8",
        "title": "FUKIEN SECONDARY SCHOOL",
        "titleCHI": "福建中學"
    },
    {
        "id": "-MFfj-6rw_vi8i8m-6SC",
        "title": "Ling Liang Church E Wun Secondary School",
        "titleCHI": "靈糧堂怡文中學"
    },
    {
        "id": "-MFfj-6rwWBsqzXwwmTu",
        "title": "STFA CHENG YU TUNG SECONDARY SCHOOL",
        "titleCHI": "順德聯誼總會鄭裕彤中學"
    },
    {
        "id": "-MFfj-6rvnW8h4xWlEHs",
        "title": "KIT SAM LAM BING YIM SECONDARY SCHOOL",
        "titleCHI": "潔心林炳炎中學"
    },
    {
        "id": "-MFfj-6rrMgYOrnbGJSI",
        "title": "YCH LAN CHI PAT MEMORIAL SECONDARY SCH",
        "titleCHI": "仁濟醫院靚次伯紀念中學"
    },
    {
        "id": "-MFfj-6rqvj3OZ6EbwiE",
        "title": "PO CHIU CATHOLIC SECONDARY SCHOOL",
        "titleCHI": "天主教普照中學"
    },
    {
        "id": "-MFfj-6rqrBx_m61HCYb",
        "title": "CCC KEI HEEP SECONDARY SCHOOL",
        "titleCHI": "中華基督教會基協中學"
    },
    {
        "id": "-MFfj-6rqWOaNqlCSTeT",
        "title": "KWUN TONG MARYKNOLL COLLEGE",
        "titleCHI": "觀塘瑪利諾書院"
    },
    {
        "id": "-MFfj-6rqReNWcWNf6XM",
        "title": "LOK SIN TONG KU CHIU MAN SEC SCH",
        "titleCHI": "樂善堂顧超文中學"
    },
    {
        "id": "-MFfj-6rqLoqJH89sCN0",
        "title": "BUDDHIST HO NAM KAM COLLEGE",
        "titleCHI": "佛教何南金中學"
    },
    {
        "id": "-MFfj-6rokT0BHT59tIM",
        "title": null,
        "titleCHI": null
    },
    {
        "id": "-MFfj-6roR4aCyMgEpiz",
        "title": "CCC CHUEN YUEN COLLEGE",
        "titleCHI": "中華基督教會全完中學"
    },
    {
        "id": "-MFfj-6ro0PoCoi07kul",
        "title": "HEUNG TO SEC SCHOOL (TSEUNG KWAN O)",
        "titleCHI": "將軍澳香島中學"
    },
    {
        "id": "-MFfj-6ro0Mf7xhEghKq",
        "title": "CCC ROTARY SECONDARY SCHOOL",
        "titleCHI": "中華基督教會扶輪中學"
    },
    {
        "id": "-MFfj-6rmyE4J8kwdPq0",
        "title": "OUR LADY'S COLLEGE",
        "titleCHI": "聖母書院"
    },
    {
        "id": "-MFfj-6rmPCO-cs9iGDT",
        "title": "LOK SIN TONG LEUNG CHIK WAI MEMORIAL SCH",
        "titleCHI": "樂善堂梁植偉紀念中學"
    },
    {
        "id": "-MFfj-6rlrXb9VAHKZmA",
        "title": "POPE PAUL VI COLLEGE",
        "titleCHI": "保祿六世書院"
    },
    {
        "id": "-MFfj-6rl_fLkmrWnl-c",
        "title": "CCC YENCHING COLLEGE",
        "titleCHI": "中華基督教會燕京書院"
    },
    {
        "id": "-MFfj-6rjng5NzTwq_-7",
        "title": "KIANGSU-CHEKIANG COLLEGE (KWAI CHUNG)",
        "titleCHI": "葵涌蘇浙公學"
    },
    {
        "id": "-MFfj-6rig32_NvQovF-",
        "title": "KO LUI SECONDARY SCHOOL",
        "titleCHI": "高雷中學"
    },
    {
        "id": "-MFfj-6riY4Azbt1anFH",
        "title": "NING PO COLLEGE",
        "titleCHI": "寧波公學"
    },
    {
        "id": "-MFfj-6rhYEVfEyfLL63",
        "title": "Delia Memorial School (Hip Wo No.2 College)",
        "titleCHI": "地利亞修女紀念學校(協和二中)"
    },
    {
        "id": "-MFfj-6rhHwj-9QMiWKo",
        "title": "YMCA Of Hong Kong Christian College",
        "titleCHI": "港青基信書院"
    },
    {
        "id": "-MFfj-6rh8CuuGXFQR2i",
        "title": "NLSI Lui Kwok Pat Fong College",
        "titleCHI": "呂郭碧鳳中學"
    },
    {
        "id": "-MFfj-6rgsB7SEIojQ2y",
        "title": "ST JOSEPH'S ANGLO-CHINESE SCHOOL",
        "titleCHI": "聖若瑟英文中學"
    },
    {
        "id": "-MFfj-6rgG_tc8WxAzgg",
        "title": "CHI LIN BUDDHIST SECONDARY SCHOOL",
        "titleCHI": "佛教志蓮中學"
    },
    {
        "id": "-MFfj-6rfq6dReP9vSP2",
        "title": null,
        "titleCHI": null
    },
    {
        "id": "-MFfj-6rfZozfesy-BRA",
        "title": "SKH Leung Kwai Yee Secondary School",
        "titleCHI": "聖公會梁季彝中學"
    },
    {
        "id": "-MFfj-6rfP7hAjypfMCq",
        "title": "PLK CELINE HO YAM TONG COLLEGE",
        "titleCHI": "保良局何蔭棠中學"
    },
    {
        "id": "-MFfj-6re6bacR1sUhYC",
        "title": "Weo Chang Pui Chung Memorial School",
        "titleCHI": "張沛松紀念中學"
    },
    {
        "id": "-MFfj-6qynC9MKgjezhg",
        "title": "BUDDHIST TAI HUNG COLLEGE",
        "titleCHI": "佛教大雄中學"
    },
    {
        "id": "-MFfj-6qwvqWFPF81b-i",
        "title": "TSUEN WAN GOVERNMENT SECONDARY SCHOOL",
        "titleCHI": "荃灣官立中學"
    },
    {
        "id": "-MFfj-6qwXJiNNPakSn7",
        "title": "TWGH SC GAW MEMORIAL COLLEGE",
        "titleCHI": "東華三院吳祥川紀念中學"
    },
    {
        "id": "-MFfj-6qvfrsbyJpwgn9",
        "title": "ST FRANCIS' CANOSSIAN COLLEGE",
        "titleCHI": "嘉諾撒聖方濟各書院"
    },
    {
        "id": "-MFfj-6qtMCvghM1pHI5",
        "title": "PLK YAO LING SUN COLLEGE",
        "titleCHI": "保良局姚連生中學"
    },
    {
        "id": "-MFfj-6qsEhxbiH1nBJf",
        "title": "ST PAUL'S SECONDARY SCHOOL",
        "titleCHI": "聖保祿中學"
    },
    {
        "id": "-MFfj-6qsE1ZE_uEZeE-",
        "title": "WAH YAN COLLEGE, HONG KONG",
        "titleCHI": "香港華仁書院"
    },
    {
        "id": "-MFfj-6qqbminZ98_4Ri",
        "title": "MARYMOUNT SECONDARY SCHOOL",
        "titleCHI": "瑪利曼中學"
    },
    {
        "id": "-MFfj-6qqEbj6Y-3CwHL",
        "title": "LIU PO SHAN MEMORIAL COLLEGE",
        "titleCHI": "廖寶珊紀念書院"
    },
    {
        "id": "-MFfj-6qlqjZzQSBqG0g",
        "title": "DMHC SIU MING CATHOLIC SEC SCH",
        "titleCHI": "天主教母佑會蕭明中學"
    },
    {
        "id": "-MFfj-6qlTQLzJw7jZ2T",
        "title": "ST MARGARET'S CO-EDU ENG SEC & PRI SCH",
        "titleCHI": "聖瑪加利男女英文中小學"
    },
    {
        "id": "-MFfj-6qkqUPTGsfSCXj",
        "title": "MARYKNOLL FATHERS' SCHOOL",
        "titleCHI": "瑪利諾神父教會學校"
    },
    {
        "id": "-MFfj-6qkgOVB5CYIyQK",
        "title": "CONCORDIA LUTHERAN SCHOOL - NORTH POINT",
        "titleCHI": "北角協同中學"
    },
    {
        "id": "-MFfj-6qkIU_7ApusTsD",
        "title": "CONCORDIA LUTHERAN SCHOOL",
        "titleCHI": "路德會協同中學"
    },
    {
        "id": "-MFfj-6qjej-wsIA_Nid",
        "title": "SKH St. Mary's Church Mok Hing Yiu College",
        "titleCHI": "莫慶堯中學"
    },
    {
        "id": "-MFfj-6qiU8g0uVUaQFM",
        "title": "TANG SHIU KIN VICTORIA GOVT SEC SCH",
        "titleCHI": "鄧肇堅維多利亞官立中學"
    },
    {
        "id": "-MFfj-6qiIGtVyZhS_cq",
        "title": "HEUNG TO MIDDLE SCHOOL",
        "titleCHI": "香島中學"
    },
    {
        "id": "-MFfj-6qi1yImVg0-c9c",
        "title": "TSUNG TSIN CHRISTIAN ACADEMY",
        "titleCHI": "基督教崇真中學"
    },
    {
        "id": "-MFfj-6qhY6HHFCmN3Rx",
        "title": "Delia Memorial School (Broadway)",
        "titleCHI": "地利亞修女紀念學校(百老匯)"
    },
    {
        "id": "-MFfj-6qgTpmYnM2SR03",
        "title": "SALESIANS OF DON BOSCO NG SIU MUI SEC SC",
        "titleCHI": "天主教慈幼會伍少梅中學"
    },
    {
        "id": "-MFfj-6qejw9NWPfzRqx",
        "title": "TSUNG TSIN MIDDLE SCHOOL",
        "titleCHI": "崇正中學"
    },
    {
        "id": "-MFfj-6qdXmYaQPmS5Go",
        "title": "TWGH LEE CHING DEA MEMORIAL COLLEGE",
        "titleCHI": "東華三院李潤田紀念中學"
    },
    {
        "id": "-MFfj-6qdUans7Nv8WRc",
        "title": "AD&FD POHL Leung Sing Tak College",
        "titleCHI": "梁省德中學"
    },
    {
        "id": "-MFfj-6qc6hkSCh0xrFS",
        "title": "Delia Memorial School (Glee Path)",
        "titleCHI": "地利亞修女紀念學校(吉利徑)"
    },
    {
        "id": "-MFfj-6qbZ3_eDr29B3B",
        "title": "PLK LEE SHING PIK COLLEGE",
        "titleCHI": "保良局李城璧中學"
    },
    {
        "id": "-MFfj-6qaBeKxvFbK-bX",
        "title": "CHINA HOLINESS COLLEGE",
        "titleCHI": "中聖書院"
    },
    {
        "id": "-MFfj-6qYL2A0OLvUs3R",
        "title": "Po On Commercial Association Wong Siu Ching Secondary School",
        "titleCHI": "王少清中學"
    },
    {
        "id": "-MFfj-6qXa2m8oLqDrcs",
        "title": "CHEUNG SHA WAN CATHOLIC SECONDARY SCHOOL",
        "titleCHI": "長沙灣天主教英文中學"
    },
    {
        "id": "-MFfj-6qXBml__O5SKSY",
        "title": "BUDDHIST YIP KEI NAM MEMORIAL COLLEGE",
        "titleCHI": "佛教葉紀南紀念中學"
    },
    {
        "id": "-MFfj-6qWd0D4RZkkUhd",
        "title": "YCH LIM POR YEN SECONDARY SCHOOL",
        "titleCHI": "仁濟醫院林百欣中學"
    },
    {
        "id": "-MFfj-6qWbm8tXkBWfqW",
        "title": "TAK NGA SECONDARY SCHOOL",
        "titleCHI": "德雅中學"
    },
    {
        "id": "-MFfj-6qWG0LYRBD1g95",
        "title": "NAM WAH CATHOLIC SECONDARY SCHOOL",
        "titleCHI": "天主教南華中學"
    },
    {
        "id": "-MFfj-6qW0Oq6zkDxraz",
        "title": "LAI KING CATHOLIC SECONDARY SCHOOL",
        "titleCHI": "荔景天主教中學"
    },
    {
        "id": "-MFfj-6qTsjBPSzZkw8g",
        "title": "SKH LI PING SECONDARY SCHOOL",
        "titleCHI": "聖公會李炳中學"
    },
    {
        "id": "-MFfj-6qTPZdGPaqFqwz",
        "title": "SKH TANG SHIU KIN SECONDARY SCHOOL",
        "titleCHI": "聖公會鄧肇堅中學"
    },
    {
        "id": "-MFfj-6qRWeBVIgbO-hN",
        "title": "LUI MING CHOI LUTHERAN COLLEGE",
        "titleCHI": "路德會呂明才中學"
    },
    {
        "id": "-MFfj-6qQNRoO1HWfDNU",
        "title": "BUDDHIST WONG FUNG LING COLLEGE",
        "titleCHI": "佛教黃鳳翎中學"
    },
    {
        "id": "-MFfj-6qQIxWfXA2k5Hv",
        "title": "METHODIST LEE WAI LEE COLLEGE",
        "titleCHI": "李惠利中學"
    },
    {
        "id": "-MFfj-6qOz78lmdFaKJR",
        "title": "TIACC Woo Hon Fai Secondary School",
        "titleCHI": "胡漢輝中學"
    },
    {
        "id": "-MFfj-6qOJBkbBbKp3wK",
        "title": "SKH LAM WOO MEMORIAL SECONDARY SCHOOL",
        "titleCHI": "聖公會林護紀念中學"
    },
    {
        "id": "-MFfj-6qOGNWBcHCy5lc",
        "title": "LINGNAN DR CHUNG WING KWONG MEM SEC SCH",
        "titleCHI": "嶺南鍾榮光博士紀念中學"
    },
    {
        "id": "-MFfj-6qODHxqT7msudB",
        "title": "Ho Fung College (Sponsored By Sik Sik Yuen)",
        "titleCHI": "可風中學"
    },
    {
        "id": "-MFfj-6qNoSd-nDe7ZbG",
        "title": "TWGH CHEN ZAO MEN COLLEGE",
        "titleCHI": "東華三院陳兆民中學"
    },
    {
        "id": "-MFfj-6qIxyZnKHBCUgh",
        "title": "BUDDHIST SIN TAK COLLEGE",
        "titleCHI": "佛教善德英文中學"
    },
    {
        "id": "-MFfj-6qIoNg1a1_GzKG",
        "title": "YING WA COLLEGE",
        "titleCHI": "英華書院"
    },
    {
        "id": "-MFfj-6qIXcN72WH8ztP",
        "title": "KOWLOON TECHNICAL SCHOOL",
        "titleCHI": "九龍工業學校"
    },
    {
        "id": "-MFfj-6qGaCusEkL2uwq",
        "title": "PLK Lo Kit Sing (1983) College",
        "titleCHI": "保良局羅傑承(一九八三)中學"
    },
    {
        "id": "-MFfj-6qEuWIZ7Ovbqzy",
        "title": "TWGH CHANG MING THIEN COLLEGE",
        "titleCHI": "東華三院張明添中學"
    },
    {
        "id": "-MFfj-6qE132u_M2Xcbz",
        "title": "HKSYC & IA Chan Nam Chong Memorial College",
        "titleCHI": "陳南昌紀念中學"
    },
    {
        "id": "-MFfj-6qDniw5SMxbS87",
        "title": "CMA SECONDARY SCHOOL",
        "titleCHI": "廠商會中學"
    },
    {
        "id": "-MFfj-6qD8U4HbdA_cjK",
        "title": "CHAN SHU KUI MEMORIAL SCHOOL",
        "titleCHI": "陳樹渠紀念中學"
    },
    {
        "id": "-MFfj-6qCdBZoyJaz_M-",
        "title": "HOTUNG SECONDARY SCHOOL",
        "titleCHI": "何東中學"
    },
    {
        "id": "-MFfj-6qCOWbJckvuB-d",
        "title": "QUEEN'S COLLEGE",
        "titleCHI": "皇仁書院"
    },
    {
        "id": "-MFfj-6qCGyDkQhBgC2x",
        "title": "WAI KIU COLLEGE",
        "titleCHI": "惠僑英文中學"
    },
    {
        "id": "-MFfj-6qAy-EDxBCfcIn",
        "title": "TRUE LIGHT MIDDLE SCHOOL OF HONG KONG",
        "titleCHI": "香港真光中學"
    },
    {
        "id": "-MFfj-6qAvl0b-VOwvI4",
        "title": "ST PAUL'S CONVENT SCHOOL",
        "titleCHI": "聖保祿學校"
    },
    {
        "id": "-MFfj-6qAc-lnanrQRV6",
        "title": "STFA LEE SHAU KEE COLLEGE",
        "titleCHI": "順德聯誼總會李兆基中學"
    },
    {
        "id": "-MFfj-6q9uQa3S4iTLi4",
        "title": "ROSARYHILL SCHOOL",
        "titleCHI": "玫瑰崗學校"
    },
    {
        "id": "-MFfj-6q8XdRkdO7koEK",
        "title": "CONFUCIUS HALL SECONDARY SCHOOL",
        "titleCHI": "孔聖堂中學"
    },
    {
        "id": "-MFfj-6q70YUfKDyyQOs",
        "title": "CCC MING YIN COLLEGE",
        "titleCHI": "中華基督教會銘賢書院"
    },
    {
        "id": "-MFfj-6q6ZzKLrXGxRnH",
        "title": "SHEK LEI CATHOLIC SECONDARY SCHOOL",
        "titleCHI": "石籬天主教中學"
    },
    {
        "id": "-MFfj-6q5fjSTQzPNFKE",
        "title": "TACK CHING GIRLS' SECONDARY SCHOOL",
        "titleCHI": "德貞女子中學"
    },
    {
        "id": "-MFfj-6q4BElBnysRosU",
        "title": "PLK TONG NAI KAN JUNIOR SEC COLLEGE",
        "titleCHI": "保良局唐乃勤初中書院"
    },
    {
        "id": "-MFfj-6q3_6WASWLUQ-6",
        "title": "ST FRANCIS XAVIER'S SCHOOL, TSUEN WAN",
        "titleCHI": "荃灣聖芳濟中學"
    },
    {
        "id": "-MFfj-6q1F2gI78qLlM0",
        "title": "CCC KUNG LEE COLLEGE",
        "titleCHI": "中華基督教會公理高中書院"
    },
    {
        "id": "-MFfj-6q0iX6cYRxYW_l",
        "title": "United Christian College",
        "titleCHI": "匯基書院"
    },
    {
        "id": "-MFfj-6q0DGhlK6eTAHg",
        "title": "TWGH MRS WU YORK YU MEMORIAL COLLEGE",
        "titleCHI": "東華三院伍若瑜夫人紀念中學"
    },
    {
        "id": "-MFfj-6q01cHkkNY1s83",
        "title": "HONG KONG TANG KING PO COLLEGE",
        "titleCHI": "香港鄧鏡波書院"
    },
    {
        "id": "-MFfj-6q016KyZ4GQWOa",
        "title": "PO LEUNG KUK CHOI KAI YAU SCHOOL",
        "titleCHI": "保良局蔡繼有學校"
    },
    {
        "id": "-MFfj-6q-Nzx2qk0GjKz",
        "title": "Tsuen Wan Public Ho Chuen Yiu Memorial College",
        "titleCHI": "何傳耀紀念中學"
    },
    {
        "id": "-MFfj-6pzgw7jMD1u_If",
        "title": "HKSYC & IA Wong Tai Shan Memorial College",
        "titleCHI": "黃棣珊紀念中學"
    },
    {
        "id": "-MFfj-6pxy07OjuB2l_Q",
        "title": "TRUE LIGHT GIRLS' COLLEGE",
        "titleCHI": "真光女書院"
    },
    {
        "id": "-MFfj-6pv_sZRrdSN4XQ",
        "title": "HKBU Affiliated School Wong Kam Fai Secondary and Primary Schoo",
        "titleCHI": "王錦輝中小學"
    },
    {
        "id": "-MFfj-6pufVnCj17pmGW",
        "title": "OUR LADY OF THE ROSARY COLLEGE",
        "titleCHI": "聖母玫瑰書院"
    },
    {
        "id": "-MFfj-6pswZ4-XVTxVh7",
        "title": "Helen Liang Memorial Secondary School (Shatin)",
        "titleCHI": "梁文燕紀念中學(沙田)"
    },
    {
        "id": "-MFfj-6ppgViKPddwJUZ",
        "title": "CCC MING KEI COLLEGE",
        "titleCHI": "中華基督教會銘基書院"
    },
    {
        "id": "-MFfj-6poUSBw2X_3jFv",
        "title": "SKH TSANG SHIU TIM SECONDARY SCHOOL",
        "titleCHI": "聖公會曾肇添中學"
    },
    {
        "id": "-MFfj-6pnzDUb7M-M-aj",
        "title": "HOLY TRINITY COLLEGE",
        "titleCHI": "寶血會上智英文書院"
    },
    {
        "id": "-MFfj-6pnFoYk4NmyJ3K",
        "title": "CHINESE YMCA COLLEGE",
        "titleCHI": "青年會書院"
    },
    {
        "id": "-MFfj-6pmMERMbEZ87wa",
        "title": "STEWARDS POOI KEI COLLEGE",
        "titleCHI": "香港神託會培基書院"
    },
    {
        "id": "-MFfj-6pktfb2lKmA91g",
        "title": "KOWLOON SAM YUK SECONDARY SCHOOL",
        "titleCHI": "九龍三育中學"
    },
    {
        "id": "-MFfj-6pkr_MM-NOl6y2",
        "title": "ST MARGARET'S GIRLS' COLLEGE, HONG KONG",
        "titleCHI": "香港聖瑪加利女書院"
    },
    {
        "id": "-MFfj-6pkYUWOVy35671",
        "title": "DIOCESAN GIRLS' SCHOOL",
        "titleCHI": "拔萃女書院"
    },
    {
        "id": "-MFfj-6pih4doYynnfTF",
        "title": "BAPTIST LUI MING CHOI SECONDARY SCHOOL",
        "titleCHI": "浸信會呂明才中學"
    },
    {
        "id": "-MFfj-6phAwJEZHNYyRS",
        "title": "TWGH WONG FUNG LING COLLEGE",
        "titleCHI": "東華三院黃鳳翎中學"
    },
    {
        "id": "-MFfj-6pdZhF2T7jxEuZ",
        "title": "PUI KIU COLLEGE",
        "titleCHI": "培僑書院"
    },
    {
        "id": "-MFfj-6pdTUEhW6aCRBC",
        "title": "YCH TUNG CHI YING MEM SEC SCHOOL",
        "titleCHI": "仁濟醫院董之英紀念中學"
    },
    {
        "id": "-MFfj-6pbxbCoGteSKlw",
        "title": "ST ROSE OF LIMA'S COLLEGE",
        "titleCHI": "聖羅撒書院"
    },
    {
        "id": "-MFfj-6p_DeAyHLSmxfR",
        "title": "CUHKFAA Chan Chun Ha Secondary School",
        "titleCHI": "陳震夏中學"
    },
    {
        "id": "-MFfj-6pYqWZL1LbX01R",
        "title": "LKWFSL LAU WONG FAT SECONDARY SCHOOL",
        "titleCHI": "世界龍岡學校劉皇發中學"
    },
    {
        "id": "-MFfj-6pY2ym7KMPF5Mp",
        "title": "SHATIN TSUNG TSIN SECONDARY SCHOOL",
        "titleCHI": "沙田崇真中學"
    },
    {
        "id": "-MFfj-6pXtQMqHgFRk0l",
        "title": "METHODIST COLLEGE",
        "titleCHI": "循道中學"
    },
    {
        "id": "-MFfj-6pXb9qOo-10t_K",
        "title": "JOCKEY CLUB TI-I COLLEGE",
        "titleCHI": "賽馬會體藝中學"
    },
    {
        "id": "-MFfj-6pWNTSbswg7Q23",
        "title": "IMMACULATE HEART OF MARY COLLEGE",
        "titleCHI": "聖母無玷聖心書院"
    },
    {
        "id": "-MFfj-6pVSYXwm4B2aRm",
        "title": "CARITAS MA ON SHAN SECONDARY SCHOOL",
        "titleCHI": "明愛馬鞍山中學"
    },
    {
        "id": "-MFfj-6pUqRqQBepWsFI",
        "title": "RENAISSANCE COLLEGE",
        "titleCHI": "啓新書院"
    },
    {
        "id": "-MFfj-6pURPGsXs559QO",
        "title": "NG YUK SECONDARY SCHOOL",
        "titleCHI": "五育中學"
    },
    {
        "id": "-MFfj-6pTg8wEoWy1MG9",
        "title": "TWGH YOW KAM YUEN COLLEGE",
        "titleCHI": "東華三院邱金元中學"
    },
    {
        "id": "-MFfj-6pTGUwhsTxks41",
        "title": "LAI CHACK MIDDLE SCHOOL",
        "titleCHI": "麗澤中學"
    },
    {
        "id": "-MFfj-6pSeNA4SoGC0_M",
        "title": "SHATIN PUI YING COLLEGE",
        "titleCHI": "沙田培英中學"
    },
    {
        "id": "-MFfj-6ozlw30LuxaR8c",
        "title": "Fukien Secondary School (Siu Sai Wan)",
        "titleCHI": "福建中學小西灣"
    },
    {
        "id": "-MFfj-6ozSynWzUEUGUQ",
        "title": "BUDDHIST TAI KWONG CHI HONG COLLEGE",
        "titleCHI": "佛教大光慈航中學"
    },
    {
        "id": "-MFfj-6ozNtxXRWrgHsg",
        "title": "VALTORTA COLLEGE",
        "titleCHI": "恩主教書院"
    },
    {
        "id": "-MFfj-6oyNpC3KDq2qXT",
        "title": "SHAU KEI WAN EAST GOVERNMENT SEC SCH",
        "titleCHI": "筲箕灣東官立中學"
    },
    {
        "id": "-MFfj-6oyHhk_zSsUPGC",
        "title": "MA ON SHAN ST JOSEPH'S SECONDARY SCHOOL",
        "titleCHI": "馬鞍山聖若瑟中學"
    },
    {
        "id": "-MFfj-6oy4DqYklQPG8q",
        "title": "YPI&CA LEE LIM MING COLLEGE",
        "titleCHI": "恩平工商會李琳明中學"
    },
    {
        "id": "-MFfj-6oxyB6iOJZ_Jcb",
        "title": "LAW TING PONG SECONDARY SCHOOL",
        "titleCHI": "羅定邦中學"
    },
    {
        "id": "-MFfj-6oxvJgo8H7Cl1u",
        "title": "HHCKLA Buddhist Ma Kam Chan Memorial English Secondary School",
        "titleCHI": "馬錦燦紀念英文中學"
    },
    {
        "id": "-MFfj-6oxPl6-pt0loKp",
        "title": "NTHYK TAI PO DISTRICT SECONDARY SCHOOL",
        "titleCHI": "新界鄉議局大埔區中學"
    },
    {
        "id": "-MFfj-6ox-YzKoIglR7h",
        "title": "ST STEPHEN'S COLLEGE",
        "titleCHI": "聖士提反書院"
    },
    {
        "id": "-MFfj-6owqPnvvvAl4Ed",
        "title": "PUI YING SECONDARY SCHOOL",
        "titleCHI": "培英中學"
    },
    {
        "id": "-MFfj-6owbGkMeIz3dBE",
        "title": "Ju Ching Chu Secondary School (Tuen Mun)",
        "titleCHI": "屯門裘錦秋中學"
    },
    {
        "id": "-MFfj-6owE3_SJsTZO0z",
        "title": "The Methodist Church HK Wesley College",
        "titleCHI": "衛理中學"
    },
    {
        "id": "-MFfj-6ow4yGgcIgwtiD",
        "title": "SKH ST SIMON'S LUI MING CHOI SEC SCH",
        "titleCHI": "聖公會聖西門呂明才中學"
    },
    {
        "id": "-MFfj-6ovZ0eg-ICYVNN",
        "title": "MA ON SHAN TSUNG TSIN SECONDARY SCHOOL",
        "titleCHI": "馬鞍山崇真中學"
    },
    {
        "id": "-MFfj-6ousas-XFtp9ru",
        "title": "SHAU KEI WAN GOVERNMENT SECONDARY SCHOOL",
        "titleCHI": "筲箕灣官立中學"
    },
    {
        "id": "-MFfj-6oufXEHcw1b1h8",
        "title": "CSBS MRS AW BOON HAW SEC SCH",
        "titleCHI": "鐘聲慈善社胡陳金枝中學"
    },
    {
        "id": "-MFfj-6oubLynVobcmo1",
        "title": "ABERDEEN BAPTIST LUI MING CHOI COLLEGE",
        "titleCHI": "香港仔浸信會呂明才書院"
    },
    {
        "id": "-MFfj-6ouZ9n5XIAsFOa",
        "title": "KIANGSU-CHEKIANG COLLEGE",
        "titleCHI": "蘇浙公學"
    },
    {
        "id": "-MFfj-6otx7r5VaJixPK",
        "title": "SOUTH TUEN MUN GOVERNMENT SEC SCH",
        "titleCHI": "南屯門官立中學"
    },
    {
        "id": "-MFfj-6otvXuTDlNEKow",
        "title": "CARITAS FANLING CHAN CHUN HA SEC SCH",
        "titleCHI": "明愛粉嶺陳震夏中學"
    },
    {
        "id": "-MFfj-6otdfjaTcXC1g-",
        "title": "SKH BISHOP MOK SAU TSENG SEC SCH",
        "titleCHI": "聖公會莫壽增會督中學"
    },
    {
        "id": "-MFfj-6otaIEHl9eWaZV",
        "title": "MADAM LAU KAM LUNG SEC SCH OF MFBM",
        "titleCHI": "妙法寺劉金龍中學"
    },
    {
        "id": "-MFfj-6otRIwBr_1Z2Yq",
        "title": "FANLING RHENISH CHURCH SECONDARY SCHOOL",
        "titleCHI": "粉嶺禮賢會中學"
    },
    {
        "id": "-MFfj-6or2Hu6b-Lqh8d",
        "title": "PENTECOSTAL LAM HON KWONG SCHOOL",
        "titleCHI": "五旬節林漢光中學"
    },
    {
        "id": "-MFfj-6oq4OkSxGQR3Qo",
        "title": "TAI PO SAM YUK SECONDARY SCHOOL",
        "titleCHI": "大埔三育中學"
    },
    {
        "id": "-MFfj-6opYrR8ieC1-33",
        "title": "TWGH KAP YAN DIRECTORS' COLLEGE",
        "titleCHI": "東華三院甲寅年總理中學"
    },
    {
        "id": "-MFfj-6opK6C6pxTpjo3",
        "title": "CONFUCIAN TAI SHING HO KWOK PUI CHUN COL",
        "titleCHI": "孔教學院大成何郭佩珍中學"
    },
    {
        "id": "-MFfj-6opHBMsYHPhLDi",
        "title": "SAN WUI COMMERCIAL SOCIETY SEC SCH",
        "titleCHI": "新會商會中學"
    },
    {
        "id": "-MFfj-6opFz5C50X_9WD",
        "title": "CNEC LAU WING SANG SECONDARY SCH",
        "titleCHI": "中華傳道會劉永生中學"
    },
    {
        "id": "-MFfj-6ooQ5txa9odEd0",
        "title": "Shi Hui Wen Secondary School",
        "titleCHI": "釋慧文中學"
    },
    {
        "id": "-MFfj-6ooJbcHRjembWC",
        "title": "PLK WU CHUNG COLLEGE",
        "titleCHI": "保良局胡忠中學"
    },
    {
        "id": "-MFfj-6onePbpwU0ZemN",
        "title": "SAN WUI COMMERCIAL SOC CHAN PAK SHA SCH",
        "titleCHI": "新會商會陳白沙紀念中學"
    },
    {
        "id": "-MFfj-6onPxyZ1tS-r2p",
        "title": "CHONG GENE HANG COLLEGE",
        "titleCHI": "張振興伉儷書院"
    },
    {
        "id": "-MFfj-6omFSuo1fj_uNP",
        "title": "CCC Tam Lee Lai Fun Memorial Secondary School",
        "titleCHI": "譚李麗芬紀念中學"
    },
    {
        "id": "-MFfj-6om32Yhyky9WaF",
        "title": "Stewards MKMCF Ma Ko Pan Memorial College",
        "titleCHI": "馬可賓紀念中學"
    },
    {
        "id": "-MFfj-6olYIEzCEPniNW",
        "title": "TIN KA PING SECONDARY SCHOOL",
        "titleCHI": "田家炳中學"
    },
    {
        "id": "-MFfj-6olEl3Mb9icOKx",
        "title": "HHCKLA BUDDHIST LEUNG CHIK WAI COLLEGE",
        "titleCHI": "香海正覺蓮社佛教梁植偉中學"
    },
    {
        "id": "-MFfj-6ol6gC8ovoyZ29",
        "title": "TSUNG TSIN COLLEGE",
        "titleCHI": "崇真書院"
    },
    {
        "id": "-MFfj-6ok8oQLjOQPBCM",
        "title": "YAN CHAI HOSPITAL NO. 2 SECONDARY SCHOOL",
        "titleCHI": "仁濟醫院第二中學"
    },
    {
        "id": "-MFfj-6ojcM2UmUL0fi5",
        "title": "Christian Alliance S C Chan Memorial College",
        "titleCHI": "宣道會陳瑞芝紀念中學"
    },
    {
        "id": "-MFfj-6oj3p2auVWHtdZ",
        "title": "PUI TAK CANOSSIAN COLLEGE",
        "titleCHI": "嘉諾撒培德書院"
    },
    {
        "id": "-MFfj-6oj1XfoU7euPx_",
        "title": "SKH LAM KAU MOW SECONDARY SCHOOL",
        "titleCHI": "聖公會林裘謀中學"
    },
    {
        "id": "-MFfj-6oidGhKrdqibM8",
        "title": "CCC Fung Leung Kit Memorial Secondary School",
        "titleCHI": "馮梁結紀念中學"
    },
    {
        "id": "-MFfj-6ohw5bVVL_JzQZ",
        "title": "TWGHS MR & MRS KWONG SIK KWAN COLLEGE",
        "titleCHI": "東華三院鄺錫坤伉儷中學"
    },
    {
        "id": "-MFfj-6ohOoTK6aS6BQm",
        "title": "LINGNAN SECONDARY SCHOOL",
        "titleCHI": "嶺南中學"
    },
    {
        "id": "-MFfj-6oh-rsmumX9gdm",
        "title": "PRECIOUS BLOOD SECONDARY SCHOOL",
        "titleCHI": "寶血女子中學"
    },
    {
        "id": "-MFfj-6ofbY4BcA98Cuq",
        "title": "PLK CENTENARY LI SHIU CHUNG MEM COLL",
        "titleCHI": "保良局百周年李兆忠紀念中學"
    },
    {
        "id": "-MFfj-6oexVGurzSvVtM",
        "title": "LINGNAN HANG YEE MEMORIAL SECONDARY SCH",
        "titleCHI": "嶺南衡怡紀念中學"
    },
    {
        "id": "-MFfj-6oeIsBehu1OW5_",
        "title": "CCC KEI SAN SECONDARY SCHOOL",
        "titleCHI": "中華基督教會基新中學"
    },
    {
        "id": "-MFfj-6odtlL0_F92ooc",
        "title": "STFA TAM PAK YU COLLEGE",
        "titleCHI": "順德聯誼總會譚伯羽中學"
    },
    {
        "id": "-MFfj-6odZkl83uwLoiD",
        "title": "HONG KONG TRUE LIGHT COLLEGE",
        "titleCHI": "香港真光書院"
    },
    {
        "id": "-MFfj-6odRtXOVX_woQz",
        "title": "Tai Kwong Hilary College",
        "titleCHI": "大光德萃書院"
    },
    {
        "id": "-MFfj-6odLMV0PfMsYeR",
        "title": "CHRISTIAN ALLIANCE COLLEGE",
        "titleCHI": "宣道中學"
    },
    {
        "id": "-MFfj-6od-1hNGPwye9z",
        "title": "YAN OI TONG TIN KA PING SECONDARY SCHOOL",
        "titleCHI": "仁愛堂田家炳中學"
    },
    {
        "id": "-MFfj-6ocDhgyqQJrM-G",
        "title": "CHIU CHOW ASSOCIATION SECONDARY SCHOOL",
        "titleCHI": "潮州會館中學"
    },
    {
        "id": "-MFfj-6ocAUDq3sORLBC",
        "title": "CHRISTIAN ALLIANCE S W CHAN MEM COLL",
        "titleCHI": "宣道會陳朱素華紀念中學"
    },
    {
        "id": "-MFfj-6obXI6Sr1hgQzL",
        "title": "FUNG KAI NO.1 SECONDARY SCHOOL",
        "titleCHI": "鳳溪第一中學"
    },
    {
        "id": "-MFfj-6oaz7Mh_QbRLvq",
        "title": "Ho Ngai College (Sponsored By Sik Sik Yuen)",
        "titleCHI": "可藝中學"
    },
    {
        "id": "-MFfj-6o_unmFGxolUFW",
        "title": "MALVERN COLLEGE HONG KONG",
        "titleCHI": "香港墨爾文國際學校"
    },
    {
        "id": "-MFfj-6o_mWvqM8-_lQI",
        "title": "CARITAS CHAI WAN MARDEN FDN SEC SCH",
        "titleCHI": "明愛柴灣馬登基金中學"
    },
    {
        "id": "-MFfj-6o_POsqtXD6r8c",
        "title": "CLEMENTI SECONDARY SCHOOL",
        "titleCHI": "金文泰中學"
    },
    {
        "id": "-MFfj-6oZy7wcb8KUpuV",
        "title": "Cognitio College (Hong Kong)",
        "titleCHI": "香港文理書院"
    },
    {
        "id": "-MFfj-6oZi2pmLazCaU0",
        "title": "AOG HEBRON SECONDARY SCHOOL",
        "titleCHI": "神召會康樂中學"
    },
    {
        "id": "-MFfj-6oZ5xLfRBReBG8",
        "title": "INDEPENDENT SCHOOLS FOUNDATION ACADEMY",
        "titleCHI": "弘立書院"
    },
    {
        "id": "-MFfj-6oYuzQ54Z0x4XB",
        "title": "VICTORIA SHANGHAI ACADEMY",
        "titleCHI": "滬江維多利亞學校"
    },
    {
        "id": "-MFfj-6oY6i08Cq43iJF",
        "title": "PLK Wai Yin College",
        "titleCHI": "保良局慧妍雅集書院"
    },
    {
        "id": "-MFfj-6oWv6_3bQojA_b",
        "title": "HKTA The Yuen Yuen Institute No.2 Secondary School",
        "titleCHI": "圓玄學院第二中學"
    },
    {
        "id": "-MFfj-6oWtWBSb4VRH_F",
        "title": "CANOSSA COLLEGE",
        "titleCHI": "嘉諾撒書院"
    },
    {
        "id": "-MFfj-6oWSvXrxSi6DaD",
        "title": "CMA CHOI CHEUNG KOK SECONDARY SCHOOL",
        "titleCHI": "廠商會蔡章閣中學"
    },
    {
        "id": "-MFfj-6oV9cGQxtI2IpV",
        "title": "TUEN MUN GOVERNMENT SECONDARY SCHOOL",
        "titleCHI": "屯門官立中學"
    },
    {
        "id": "-MFfj-6oUsg--fhb9ISX",
        "title": "CCC HOH FUK TONG COLLEGE",
        "titleCHI": "中華基督教會何福堂書院"
    },
    {
        "id": "-MFfj-6oURkdQPopG6Gv",
        "title": "CHING CHUNG HAU PO WOON SEC SCH",
        "titleCHI": "青松侯寶垣中學"
    },
    {
        "id": "-MFfj-6oU0RcXUc_Qz9Y",
        "title": "TWGH SUN HOI DIRECTORS' COLLEGE",
        "titleCHI": "東華三院辛亥年總理中學"
    },
    {
        "id": "-MFfj-6oTO_Fgye8ay6P",
        "title": "LUI CHEUNG KWONG LUTHERAN COLLEGE",
        "titleCHI": "路德會呂祥光中學"
    },
    {
        "id": "-MFfj-6oS-tyEN35WIhO",
        "title": "PAOC KA CHI SECONDARY SCHOOL",
        "titleCHI": "加拿大神召會嘉智中學"
    },
    {
        "id": "-MFfj-6oRWPmqoz0gVJC",
        "title": "SKH LI FOOK HING SECONDARY SCHOOL",
        "titleCHI": "聖公會李福慶中學"
    },
    {
        "id": "-MFfj-6oRQe3sSv5cbui",
        "title": "TWGH LI KA SHING COLLEGE",
        "titleCHI": "東華三院李嘉誠中學"
    },
    {
        "id": "-MFfj-6oQO-0Ih_f3b6-",
        "title": "ISLAMIC KASIM TUET MEMORIAL COLLEGE",
        "titleCHI": "伊斯蘭脫維善紀念中學"
    },
    {
        "id": "-MFfj-6oP3Xyms6e6J_N",
        "title": "LING LIANG CHURCH M H LAU SECONDARY SCH",
        "titleCHI": "靈糧堂劉梅軒中學"
    },
    {
        "id": "-MFfj-6oOdCANzDiDf6Y",
        "title": "CHINA HOLINESS CHURCH LIVING SPIRIT COLL",
        "titleCHI": "中華聖潔會靈風中學"
    },
    {
        "id": "-MFfj-6oODM2O25Wl1kg",
        "title": "ST JOAN OF ARC SECONDARY SCHOOL",
        "titleCHI": "聖貞德中學"
    },
    {
        "id": "-MFfj-6oNAMHXmJ4wwhm",
        "title": "FANLING GOVERNMENT SECONDARY SCHOOL",
        "titleCHI": "粉嶺官立中學"
    },
    {
        "id": "-MFfj-6oMFfGi_ALAuE8",
        "title": "STFA LEUNG KAU KUI COLLEGE",
        "titleCHI": "順德聯誼總會梁銶琚中學"
    },
    {
        "id": "-MFfj-6oLzD31ohWSopz",
        "title": "BUDDHIST SUM HEUNG LAM MEMORIAL COLLEGE",
        "titleCHI": "佛教沈香林紀念中學"
    },
    {
        "id": "-MFfj-6oLbChW9NDMC_x",
        "title": "HONG KONG CHINESE WOMEN'S CLUB COLLEGE",
        "titleCHI": "香港中國婦女會中學"
    },
    {
        "id": "-MFfj-6oLP2kyHAFRXfK",
        "title": "CARMEL PAK U SECONDARY SCHOOL",
        "titleCHI": "迦密柏雨中學"
    },
    {
        "id": "-MFfj-6oL7_tfVrPSPfk",
        "title": "GCC&ITKD LAU PAK LOK SEC SCH",
        "titleCHI": "東莞工商總會劉百樂中學"
    },
    {
        "id": "-MFfj-6oKAGCEgV3Ju1W",
        "title": "HENRIETTA SECONDARY SCHOOL",
        "titleCHI": "顯理中學"
    },
    {
        "id": "-MFfj-6oJjkf423ZHvBL",
        "title": "CARITAS TUEN MUN MARDEN FDN SEC SCH",
        "titleCHI": "明愛屯門馬登基金中學"
    },
    {
        "id": "-MFfj-6oJ1D8SyO2NYZ7",
        "title": "CHEUNG CHUK SHAN COLLEGE",
        "titleCHI": "張祝珊英文中學"
    },
    {
        "id": "-MFfj-6oIg_VGRUhkkrs",
        "title": "MAN KIU COLLEGE",
        "titleCHI": "閩僑中學"
    },
    {
        "id": "-MFfj-6oIQpOB9-q5SXD",
        "title": "SKH LUI MING CHOI SECONDARY SCHOOL",
        "titleCHI": "聖公會呂明才中學"
    },
    {
        "id": "-MFfj-6oIDBiBAmlmSpL",
        "title": "THE CHINESE FOUNDATION SECONDARY SCHOOL",
        "titleCHI": "中華基金中學"
    },
    {
        "id": "-MFfj-6oI6e0Ap791fqr",
        "title": "SALESIAN ENGLISH SCHOOL",
        "titleCHI": "慈幼英文學校"
    },
    {
        "id": "-MFfj-6oI-uMlYQLttyd",
        "title": "TWGH YAU TZE TIN MEM COLLEGE",
        "titleCHI": "東華三院邱子田紀念中學"
    },
    {
        "id": "-MFfj-6oHunhZuC-M84x",
        "title": "SEMPLE MEMORIAL SECONDARY SCHOOL",
        "titleCHI": "深培中學"
    },
    {
        "id": "-MFfj-6oHpWR43MtmwXA",
        "title": "CARITAS CHONG YUET MING SEC SCH",
        "titleCHI": "明愛莊月明中學"
    },
    {
        "id": "-MFfj-6oHk5K66fKVILp",
        "title": "Tai Po Government Secondary School",
        "titleCHI": "大埔官立中學"
    },
    {
        "id": "-MFfj-6oH6kzXGLcYdSQ",
        "title": "SKH CHAN YOUNG SECONDARY SCHOOL",
        "titleCHI": "聖公會陳融中學"
    },
    {
        "id": "-MFfj-6nwF3gPHffPC9D",
        "title": "DIOCESAN BOYS' SCHOOL",
        "titleCHI": "拔萃男書院"
    },
    {
        "id": "-MFfj-6nw0kwaWOEnGPI",
        "title": "ST LOUIS SCHOOL",
        "titleCHI": "聖類斯中學"
    },
    {
        "id": "-MFfj-6nuir2kJiNHMtr",
        "title": "YUEN LONG CATHOLIC SECONDARY SCHOOL",
        "titleCHI": "元朗天主教中學"
    },
    {
        "id": "-MFfj-6nuZX10wkVNBnt",
        "title": "TWGH LO KON TING MEMORIAL COLLEGE",
        "titleCHI": "東華三院盧幹庭紀念中學"
    },
    {
        "id": "-MFfj-6nu88nzcbf5bUy",
        "title": "PLK MA KAM MING COLLEGE",
        "titleCHI": "保良局馬錦明中學"
    },
    {
        "id": "-MFfj-6nu2Nq9lhXMJ3R",
        "title": "PUI CHING MIDDLE SCHOOL",
        "titleCHI": "香港培正中學"
    },
    {
        "id": "-MFfj-6ntW6zwFjf0PrF",
        "title": "STFA YUNG YAU COLLEGE",
        "titleCHI": "順德聯誼總會翁祐中學"
    },
    {
        "id": "-MFfj-6ntJBT-Qm0JrBd",
        "title": "HKTA Tang Hin Memorial Secondary School",
        "titleCHI": "鄧顯紀念中學"
    },
    {
        "id": "-MFfj-6nsVxKLXzRfJeu",
        "title": "CUHKFAA Thomas Cheung Secondary School",
        "titleCHI": "張煊昌中學"
    },
    {
        "id": "-MFfj-6ns2ur6W-rKr46",
        "title": "TIN SHUI WAI GOVERNMENT SECONDARY SCHOOL",
        "titleCHI": "天水圍官立中學"
    },
    {
        "id": "-MFfj-6nrZMsRxgaT5gR",
        "title": "STFA SEAWARD WOO COLLEGE",
        "titleCHI": "順德聯誼總會胡兆熾中學"
    },
    {
        "id": "-MFfj-6nr6lKq4_KOYPy",
        "title": "PENTECOSTAL SCHOOL",
        "titleCHI": "五旬節中學"
    },
    {
        "id": "-MFfj-6npeYAEwf31CRM",
        "title": "NOTRE DAME COLLEGE",
        "titleCHI": "獻主會聖母院書院"
    },
    {
        "id": "-MFfj-6noyltdQYG1-76",
        "title": "TWGH KWOK YAT WAI COLLEGE",
        "titleCHI": "東華三院郭一葦中學"
    },
    {
        "id": "-MFfj-6nnwMo9iUJuNoj",
        "title": "JOCKEY CLUB EDUYOUNG COLLEGE",
        "titleCHI": "賽馬會毅智書院"
    },
    {
        "id": "-MFfj-6nn5D-oBLRJluC",
        "title": "YWCA HIOE TJO YOENG COLLEGE",
        "titleCHI": "基督教女青年會丘佐榮中學"
    },
    {
        "id": "-MFfj-6nlwzWCQMNJxAn",
        "title": "QES OLD STUDENTS' ASSOCIATION SEC SCH",
        "titleCHI": "伊利沙伯中學舊生會中學"
    },
    {
        "id": "-MFfj-6nlug8mjkbdwDC",
        "title": "HOI PING CHAMBER OF COMMERCE SEC SCH",
        "titleCHI": "旅港開平商會中學"
    },
    {
        "id": "-MFfj-6nlZ9VgkVlO8Ip",
        "title": "CCC KEI YUEN COLLEGE",
        "titleCHI": "中華基督教會基元中學"
    },
    {
        "id": "-MFfj-6nl2lYriVVbqaE",
        "title": "RAIMONDI COLLEGE",
        "titleCHI": "高主教書院"
    },
    {
        "id": "-MFfj-6nkbv4Whj5CBNS",
        "title": "HKFYG LEE SHAU KEE COLLEGE",
        "titleCHI": "香港青年協會李兆基書院"
    },
    {
        "id": "-MFfj-6nkKQ_HaWTpEpR",
        "title": "HKMA K S LO COLLEGE",
        "titleCHI": "香港管理專業協會羅桂祥中學"
    },
    {
        "id": "-MFfj-6ni9gMyexmNq2u",
        "title": "RHENISH CHURCH PANG HOK-KO MEMORIAL COLL",
        "titleCHI": "禮賢會彭學高紀念中學"
    },
    {
        "id": "-MFfj-6ni08VTWiBxDa8",
        "title": "MUNSANG COLLEGE",
        "titleCHI": "民生書院"
    },
    {
        "id": "-MFfj-6nhhpxnJLrKGMC",
        "title": "CARMEL SECONDARY SCHOOL",
        "titleCHI": "迦密中學"
    },
    {
        "id": "-MFfj-6ngfpO6jMquGgl",
        "title": "CHINESE YMCA SECONDARY SCHOOL",
        "titleCHI": "中華基督教青年會中學"
    },
    {
        "id": "-MFfj-6ngRei-8kfEcNu",
        "title": "POH TANG PUI KING MEMORIAL COLLEGE",
        "titleCHI": "博愛醫院鄧佩瓊紀念中學"
    },
    {
        "id": "-MFfj-6nfkJJR2ubpAxb",
        "title": "HEUNG TO MIDDLE SCHOOL (TIN SHUI WAI)",
        "titleCHI": "天水圍香島中學"
    },
    {
        "id": "-MFfj-6nfRc-zR3g-2Ml",
        "title": "PO LEUNG KUK NGAN PO LING COLLEGE",
        "titleCHI": "保良局顏寶鈴書院"
    },
    {
        "id": "-MFfj-6nfMzOWXo5gM18",
        "title": "Ju Ching Chu Secondary School (Yuen Long)",
        "titleCHI": "元朗裘錦秋中學"
    },
    {
        "id": "-MFfj-6nf1dim86h0nvl",
        "title": "Chan Sui Ki (La Salle) College",
        "titleCHI": "陳瑞祺喇沙書院"
    },
    {
        "id": "-MFfj-6ndoQeCigjoFsF",
        "title": "ST STEPHEN'S GIRLS' COLLEGE",
        "titleCHI": "聖士提反女子中學"
    },
    {
        "id": "-MFfj-6ndJkKyagszA0O",
        "title": "HKICC Lee Shau Kee School Of Creativity",
        "titleCHI": "香港兆基創意書院"
    },
    {
        "id": "-MFfj-6ncODumCBjVp1L",
        "title": "Cognitio College (Kowloon)",
        "titleCHI": "九龍文理書院"
    },
    {
        "id": "-MFfj-6nbhYuqm9WcqFF",
        "title": "CHIU LUT SAU MEMORIAL SECONDARY SCHOOL",
        "titleCHI": "趙聿修紀念中學"
    },
    {
        "id": "-MFfj-6naFWBdyGm2YVX",
        "title": "POOI TO MIDDLE SCHOOL",
        "titleCHI": "香港培道中學"
    },
    {
        "id": "-MFfj-6nZFSpgZ15uZy-",
        "title": "ELCHK Yuen Long Lutheran Secondary School",
        "titleCHI": "元朗信義中學"
    },
    {
        "id": "-MFfj-6nYFyOJG2CHIi1",
        "title": "ST STEPHEN'S CHURCH COLLEGE",
        "titleCHI": "聖士提反堂中學"
    },
    {
        "id": "-MFfj-6nXmQopp28Fslx",
        "title": "TANG KING PO SCHOOL",
        "titleCHI": "鄧鏡波學校"
    },
    {
        "id": "-MFfj-6nXgW1NXyq6pEp",
        "title": "BETHEL HIGH SCHOOL",
        "titleCHI": "伯特利中學"
    },
    {
        "id": "-MFfj-6nW9IT0D9z4Vle",
        "title": "CCC KEI TO SEC SCH",
        "titleCHI": "中華基督教會基道中學"
    },
    {
        "id": "-MFfj-6nVsEIbDbxMJFI",
        "title": "HOMANTIN GOVERNMENT SECONDARY SCHOOL",
        "titleCHI": "何文田官立中學"
    },
    {
        "id": "-MFfj-6nSWpj0ArSrDW0",
        "title": "PUI SHING CATHOLIC SECONDARY SCHOOL",
        "titleCHI": "天主教培聖中學"
    },
    {
        "id": "-MFfj-6nRQWzGNggytBr",
        "title": "CCC FONG YUN WAH SECONDARY SCHOOL",
        "titleCHI": "中華基督教會方潤華中學"
    },
    {
        "id": "-MFfj-6nQqCj7TSeAsUe",
        "title": "LOK SIN TONG LEUNG KAU KUI COLLEGE",
        "titleCHI": "樂善堂梁銶琚書院"
    },
    {
        "id": "-MFfj-6nQNNUelOE-IzD",
        "title": "TWGH WONG FUT NAM COLLEGE",
        "titleCHI": "東華三院黃笏南中學"
    },
    {
        "id": "-MFfj-6nP701H5VuKHvZ",
        "title": "SKH HOLY CARPENTER SECONDARY SCHOOL",
        "titleCHI": "聖公會聖匠中學"
    },
    {
        "id": "-MFfj-6nO-qMDrKHpe1H",
        "title": "GERTRUDE SIMON LUTHERAN COLLEGE",
        "titleCHI": "路德會西門英才中學"
    },
    {
        "id": "-MFfj-6nNa2TotJTG9Jn",
        "title": "The Yuen Yuen Institute MFBM Nei Ming Chan Lui Chung Tak Memorial College",
        "titleCHI": "陳呂重德紀念中學"
    },
    {
        "id": "-MFfj-6nNFwB6vsSyQhd",
        "title": "SKH TSOI KUNG PO SECONDARY SCHOOL",
        "titleCHI": "聖公會蔡功譜中學"
    },
    {
        "id": "-MFfj-6nMaQswiEeaPnS",
        "title": "Kowloon Tong School (Secondary Section)",
        "titleCHI": "九龍塘學校"
    },
    {
        "id": "-MFfj-6nKiuGSxi3-jQe",
        "title": "CCC KEI LONG COLLEGE",
        "titleCHI": "中華基督教會基朗中學"
    },
    {
        "id": "-MFfj-6nKB2t6x8VeCdg",
        "title": "FUNG KAI LIU MAN SHEK TONG SEC SCH",
        "titleCHI": "鳳溪廖萬石堂中學"
    },
    {
        "id": "-MFfj-6nJo8pbcIIAbxY",
        "title": "YUEN LONG MERCHANTS ASSOCIATION SEC SCH",
        "titleCHI": "元朗商會中學"
    },
    {
        "id": "-MFfj-6nJXjA5wQPw7GN",
        "title": "CUMBERLAND PRESBYTN CH YAO DAO SEC SCH",
        "titleCHI": "金巴崙長老會耀道中學"
    },
    {
        "id": "-MFfj-6nIk_ZfInhKief",
        "title": "KOWLOON TRUE LIGHT SCHOOL",
        "titleCHI": "九龍真光中學"
    },
    {
        "id": "-MFfj-6nI3aC4k7yjuw6",
        "title": "YING WA GIRLS' SCHOOL",
        "titleCHI": "英華女學校"
    },
    {
        "id": "-MFfj-6nH_3EAd5tRy_E",
        "title": "ST CLARE'S GIRLS' SCHOOL",
        "titleCHI": "聖嘉勒女書院"
    },
    {
        "id": "-MFfj-6nG5zlHbMClAvp",
        "title": "Queen Elizabeth School Old Students' Association Tong Kwok Wah Secondary School",
        "titleCHI": "湯國華中學"
    },
    {
        "id": "-MFfj-6nFdRgp1MgIr1-",
        "title": "Tin Shui Wai Methodist College",
        "titleCHI": "天水圍循道衛理中學"
    },
    {
        "id": "-MFfj-6nFUBmOzg8z4wL",
        "title": "ST PAUL'S COLLEGE",
        "titleCHI": "聖保羅書院"
    },
    {
        "id": "-MFfj-6nF8svTVQXWISO",
        "title": "BISHOP HALL JUBILEE SCHOOL",
        "titleCHI": "何明華會督銀禧中學"
    },
    {
        "id": "-MFfj-6nEbbTguDpL00W",
        "title": "HOLY FAMILY CANOSSIAN COLLEGE",
        "titleCHI": "嘉諾撒聖家書院"
    },
    {
        "id": "-MFfj-6nE2wHKlIxd7Xx",
        "title": "SCIENTIA SECONDARY SCHOOL",
        "titleCHI": "創知中學"
    },
    {
        "id": "-MFfj-6nDzc4w7q5XSld",
        "title": "Ho Dao College (Sponsored By Sik Sik Yuen)",
        "titleCHI": "可道中學"
    },
    {
        "id": "-MFfj-6nDoPrkaxpIbZ7",
        "title": "WA YING COLLEGE",
        "titleCHI": "華英中學"
    },
    {
        "id": "-MFfj-6nDl2IpHCnwXbI",
        "title": "SKH BISHOP BAKER SECONDARY SCHOOL",
        "titleCHI": "聖公會白約翰會督中學"
    },
    {
        "id": "-MFfj-6nDbnZJXgZJGXW",
        "title": "YUEN LONG PUBLIC SECONDARY SCHOOL",
        "titleCHI": "元朗公立中學"
    },
    {
        "id": "-MFfj-6nCSa-oqCVXJ6x",
        "title": "LA SALLE COLLEGE",
        "titleCHI": "喇沙書院"
    },
    {
        "id": "-MFfj-6nC-1GDs1XktiD",
        "title": "SKH HOLY TRINITY CHURCH SECONDARY SCHOOL",
        "titleCHI": "聖公會聖三一堂中學"
    },
    {
        "id": "-MFfj-6nBs0rppzf3oap",
        "title": "ELCHK Lutheran Academy",
        "titleCHI": "宏信書院"
    },
    {
        "id": "-MFfj-6nAkk85bCR3HUo",
        "title": "SPHRC KUNG YIK SHE SECONDARY SCHOOL",
        "titleCHI": "十八鄉鄉事委員會公益社中學"
    },
    {
        "id": "-MFfj-6nAi_eWGB6uEi-",
        "title": "YLPMSAA Tang Siu Tong Secondary School",
        "titleCHI": "鄧兆棠中學"
    },
    {
        "id": "-MFfj-6nAJf_jtliCmPU",
        "title": "TWGH CY MA MEMORIAL COLLEGE",
        "titleCHI": "東華三院馬振玉紀念中學"
    },
    {
        "id": "-MFfj-6n9kxNoi2cLSsr",
        "title": "SHUNG TAK CATHOLIC ENGLISH COLLEGE",
        "titleCHI": "天主教崇德英文書院"
    },
    {
        "id": "-MFfj-6n9ZrOSuPXeD_7",
        "title": "KING'S COLLEGE",
        "titleCHI": "英皇書院"
    },
    {
        "id": "-MFfj-6n9-HzWnk-tTWU",
        "title": "NEW ASIA MIDDLE SCHOOL",
        "titleCHI": "新亞中學"
    },
    {
        "id": "-MFfj-6n8qzG_To78KLb",
        "title": "SHEUNG SHUI GOVERNMENT SECONDARY SCHOOL",
        "titleCHI": "上水官立中學"
    },
    {
        "id": "-MFfj-6n8mubHRNdBjeH",
        "title": "YU CHUN KEUNG MEMORIAL COLLEGE",
        "titleCHI": "余振強紀念中學"
    },
    {
        "id": "-MFfj-6n7rANWt5CXtZW",
        "title": "HEEP YUNN SCHOOL",
        "titleCHI": "協恩中學"
    },
    {
        "id": "-MFfj-6n7maGB7Iz4Yfz",
        "title": "ST JOSEPH'S COLLEGE",
        "titleCHI": "聖若瑟書院"
    },
    {
        "id": "-MFfj-6n7erGC9w2Hl-e",
        "title": "JOCKEY CLUB GOVERNMENT SEC SCH",
        "titleCHI": "賽馬會官立中學"
    },
    {
        "id": "-MFfj-6n7ZRynWP1Nftp",
        "title": "PAK KAU COLLEGE",
        "titleCHI": "伯裘書院"
    },
    {
        "id": "-MFfj-6n6jptVVMUxeO8",
        "title": "BUDDHIST MAU FUNG MEMORIAL COLLEGE",
        "titleCHI": "佛教茂峰法師紀念中學"
    },
    {
        "id": "-MFfj-6n5ZJmVQ6fFy6e",
        "title": "Maryknoll Convent School (Secondary Section)",
        "titleCHI": "瑪利諾修院學校"
    },
    {
        "id": "-MFfj-6n3lsRWsT-2V0n",
        "title": "NTHYK YUEN LONG DISTRICT SECONDARY SCH",
        "titleCHI": "新界鄉議局元朗區中學"
    },
    {
        "id": "-MFfj-6n0gB4K27o4FjA",
        "title": "ST. TERESA SECONDARY SCHOOL",
        "titleCHI": "德蘭中學"
    },
    {
        "id": "-MFfj-6n-vzt5mnF3M50",
        "title": "ST PAUL'S CO-EDUCATIONAL COLLEGE",
        "titleCHI": "聖保羅男女中學"
    },
    {
        "id": "-MFfj-6n-RpsHdl95liY",
        "title": "CARITAS YL CHAN CHUN HA SEC SCH",
        "titleCHI": "明愛元朗陳震夏中學"
    }
]
